import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './AdminDashboard.css';
import config from '../config';

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [currentUser, setCurrentUser] = useState(null); // logged-in user (with role)
    const [activeTab, setActiveTab] = useState('users');
    const [users, setUsers] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [filterRole, setFilterRole] = useState('all');
    const [sortBy, setSortBy] = useState('lastActive_desc');
    
    // Server-side pagination
  
    
    // Client-side pagination State (for display)
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage, setUsersPerPage] = useState(10);
    
    // Power BI State
    const [availableDashboards, setAvailableDashboards] = useState([]);
    const [availableDatabricksDashboards, setAvailableDatabricksDashboards] = useState([]);
    // const [loadingPowerBI, setLoadingPowerBI] = useState(false); // Removed unused variable

    // PowerBI Preview State — tracks the client selected for live preview in Roles tab
    const [selectedClientForPreview, setSelectedClientForPreview] = useState(null); // client object
    const [previewDashboards, setPreviewDashboards] = useState([]); // dashboardIds assigned to preview client
    const [previewLoading, setPreviewLoading] = useState(false);

    const [showAddUserModal, setShowAddUserModal] = useState(false);
    const [showEditUserModal, setShowEditUserModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    
    // Clients State
    const [clients, setClients] = useState([]);
    const [showAddClientModal, setShowAddClientModal] = useState(false);
    const [showEditClientModal, setShowEditClientModal] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [newClientData, setNewClientData] = useState({ name: '', description: '' });
    const [showClientAssignModal, setShowClientAssignModal] = useState(false);
    const [selectedUserForClient, setSelectedUserForClient] = useState(null);
    const [userClientsMap, setUserClientsMap] = useState({}); // user email -> client names
    const [clientSpnsMap, setClientSpnsMap] = useState({}); // client name -> SPNs
    const [loadingClients, setLoadingClients] = useState(false);
    const [newUserData, setNewUserData] = useState({
        displayName: '',
        userPrincipalName: '',
        accountEnabled: true,
        userType: 'GuestInvite',
        sendInvitationMessage: true
    });
    const [userFormError, setUserFormError] = useState('');
    const [userFormSuccess, setUserFormSuccess] = useState('');
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    
    // Bulk Import State
    const [showBulkImportModal, setShowBulkImportModal] = useState(false);
    const [bulkImportFile, setBulkImportFile] = useState(null);
    const [bulkImportData, setBulkImportData] = useState([]);
    const [bulkImportErrors, setBulkImportErrors] = useState([]);
    const [bulkImportLoading, setBulkImportLoading] = useState(false);
    const [bulkImportSuccess, setBulkImportSuccess] = useState('');
    
    // Genies/SPN Management State
    const [spnUsers, setSpnUsers] = useState([]);
    const [allSpns, setAllSpns] = useState([]);
    // const [selectedSpnUser, setSelectedSpnUser] = useState(''); // Removed - not used
    // const [selectedSpn, setSelectedSpn] = useState(''); // Removed - not used
    const [spnLoading, setSpnLoading] = useState(false);
    
    // Role Modal State
    const [showRoleModal, setShowRoleModal] = useState(false);
    const [editingRole, setEditingRole] = useState(null);
    const [roleFormData, setRoleFormData] = useState({
        name: '',
        features: []
    });

    // Databricks Overview Dialog State (shown from SPN-Genies tab)
    const [showDatabricksOverviewModal, setShowDatabricksOverviewModal] = useState(false);
    const [databricksSpns, setDatabricksSpns] = useState([]);
    const [databricksGenieSpaces, setDatabricksGenieSpaces] = useState([]);
    const [databricksHost, setDatabricksHost] = useState('');
    const [databricksLoading, setDatabricksLoading] = useState(false);
    const [databricksError, setDatabricksError] = useState('');
    
    // Multi-Databricks Support
    const [selectedDatabricksHosts, setSelectedDatabricksHosts] = useState(['LOCAL_DATABRICKS_HOST']); // Default to the main one
    const [availableDatabricksHosts] = useState([
        { id: 'LOCAL_DATABRICKS_HOST', name: 'Default Databricks' },
        { id: 'TRIPSHOT_DATABRICKS_HOST', name: 'Tripshot Databricks' },
        { id: 'ECOLANE_DATABRICKS_HOST', name: 'Ecolane Databricks' }
    ]);
    const [showWorkspaceDropdown, setShowWorkspaceDropdown] = useState(false);
    
    // Pagination for overview dialog
    const [overviewSpnPage, setOverviewSpnPage] = useState(1);
    const [overviewGeniePage, setOverviewGeniePage] = useState(1);
    const OVERVIEW_PAGE_SIZE = 10;

    // SPN-Genies tab state
    const [spnGenieMap, setSpnGenieMap] = useState([]);           // [{scimId, name, hasOAuthCredentials, genies:[{id,title}]}]
    const [spnGenieAllSpaces, setSpnGenieAllSpaces] = useState([]); // [{id, title}] — all available genie spaces
    const [spnGenieLoading, setSpnGenieLoading] = useState(false);
    const [spnGenieError, setSpnGenieError] = useState('');
    const [spnGenieHost, setSpnGenieHost] = useState('');
    // SPN-Genies tab filter/search state
    const [spnGenieSearch, setSpnGenieSearch] = useState('');
    const [spnGenieFilter, setSpnGenieFilter] = useState('all'); // 'all' | 'oauth' | 'no-oauth' | 'scim' | 'no-scim' | 'with-genies' | 'no-genies'
    const [spnGenieMappedOnly, setSpnGenieMappedOnly] = useState(false); // show only SPNs mapped to a client
    // Add-genie modal
    const [showAddGenieModal, setShowAddGenieModal] = useState(false);
    const [addGenieTarget, setAddGenieTarget] = useState(null);   // the SPN object being edited
    const [addGenieSearch, setAddGenieSearch] = useState('');
    const [addGenieSaving, setAddGenieSaving] = useState(false);
    const [addGenieError, setAddGenieError] = useState('');

    // Test-genie modal
    const [showTestGenieModal, setShowTestGenieModal] = useState(false);
    const [testGenieTarget, setTestGenieTarget] = useState(null);   // the SPN object being tested
    const [testGenieResults, setTestGenieResults] = useState(null); // null = not run yet
    const [testGenieLoading, setTestGenieLoading] = useState(false);
    const [testGenieError, setTestGenieError] = useState('');

    useEffect(() => {
        // Fetch logged-in user info (including role) on mount
        const fetchCurrentUser = async () => {
            try {
                const response = await axios.get(`${config.apiUrl}/api/user`, { withCredentials: true });
                const data = response.data;
                // Normalise role: handle legacy 'super admin' (space) → 'super_admin' (underscore)
                if (data && data.role) {
                    data.role = data.role.toLowerCase().replace(' ', '_');
                }
                setCurrentUser(data);
            } catch (err) {
                console.error('[AdminDashboard] Failed to fetch current user:', err);
            }
        };
        fetchCurrentUser();

        // Fetch core data on initial mount
        fetchUsers();
        fetchClients();
        // Also fetch client SPNs on mount so they're available for roles tab display
        fetchClientSpns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array - run only once on mount

    // Separate effect for roles tab-specific data
    useEffect(() => {
        if (activeTab === 'roles') {
            fetchSpnData(); // Fetch user-SPN mappings
            fetchClientsPowerBIStatus(); // Fetch Power BI status for roles tab
            fetchAvailableDashboards(); // Fetch Power BI dashboards from PowerBI.json
            fetchAvailableDatabricksDashboards(); // Fetch Databricks AI/BI dashboards
            // Note: fetchClientSpns() already called on mount, no need to call again
        }
        if (activeTab === 'spn-genies') {
            fetchSpnGenieMap();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            // Fetch ALL users in a single request by using a very large limit.
            // The server now also defaults to 2000 so any stray call without
            // a limit param is also safe.  If the tenant ever exceeds 2000 users
            // the loop below will automatically paginate to collect all pages.
            const PAGE_SIZE = 2000;
            let allUsers = [];
            let page = 1;
            let hasMore = true;

            while (hasMore) {
                const response = await axios.get(`${config.apiUrl}/api/admin/azure-users`, {
                    params: { page, limit: PAGE_SIZE }
                });
                const pageUsers = response.data.users || [];
                allUsers = [...allUsers, ...pageUsers];
                hasMore = response.data.hasMore === true;
                page++;
            }

            // Normalise roles: handle legacy 'super admin' (space) → 'super_admin' (underscore)
            const normalizedUsers = allUsers.map(u => ({
                ...u,
                role: u.role ? u.role.toLowerCase().replace(' ', '_') : u.role
            }));
            setUsers(normalizedUsers);
        } catch (error) {
            console.error('[ADMIN] Error fetching users:', error);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };
    
    // Filter users based on search and role
    const filteredUsers = users.filter(user => {
        const matchesSearch = user.displayName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                            user.mail?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                            user.userPrincipalName?.toLowerCase().includes(searchQuery.toLowerCase());
        
        const matchesRole = filterRole === 'all' || user.role === filterRole;
        
        return matchesSearch && matchesRole;
    });

    // Reset to page 1 when search, filter, or sort changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery, filterRole, sortBy]);

    // Fetch client mappings for currently visible users only (page-wise)
    // Note: depends on currentPage/usersPerPage state; actual currentUsers slice is computed in fetchUserClientsForCurrentPage
    useEffect(() => {
        fetchUserClientsForCurrentPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, usersPerPage, users, sortBy, searchQuery, filterRole]); // Re-fetch when page or filters change

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        // Scroll to top of table
        document.querySelector('.admin-table-container')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handleUsersPerPageChange = (e) => {
        setUsersPerPage(Number(e.target.value));
        setCurrentPage(1); // Reset to first page
    };

    // Stats (totalUsers, activeUsers, pendingUsers) and recentActivity can be added here for future dashboard summary UI

    const getRoleBadgeClass = (role) => {
        // Normalise: handle both 'super admin' (legacy) and 'super_admin'
        const r = (role || '').toLowerCase().replace(' ', '_');
        switch(r) {
            case 'admin': return 'role-badge-admin';
            case 'super_admin': return 'role-badge-super_admin';
            case 'viewer': return 'role-badge-viewer';
            default: return 'role-badge-viewer';
        }
    };

    const getRoleDisplayName = (role) => {
        const r = (role || '').toLowerCase().replace(' ', '_');
        switch(r) {
            case 'super_admin': return 'Super Admin';
            case 'admin': return 'Admin';
            case 'viewer': return 'Viewer';
            default: return 'Viewer';
        }
    };

    const getUserActivityStatus = (user) => {
        // Priority 1: Check last_activity (any API call)
        const lastActivity = user.lastActivity || user.last_activity;
        
        if (lastActivity) {
            const activityDate = new Date(lastActivity);
            const now = new Date();
            const diffMinutes = Math.floor((now - activityDate) / 60000);
            
            // Active: within last 15 minutes
            if (diffMinutes < 15) {
                return { status: 'Active', class: 'status-badge-active' };
            }
            // Away: 15 minutes to 24 hours
            else if (diffMinutes < 1440) {
                return { status: 'Away', class: 'status-badge-away' };
            }
            // Inactive: over 24 hours
            else {
                return { status: 'Inactive', class: 'status-badge-inactive' };
            }
        }
        
        // Priority 2: Fallback to last_login
        const lastLogin = user.lastLogin || user.last_login;
        if (lastLogin) {
            const loginDate = new Date(lastLogin);
            const now = new Date();
            const diffMinutes = Math.floor((now - loginDate) / 60000);
            
            if (diffMinutes < 15) {
                return { status: 'Active', class: 'status-badge-active' };
            } else if (diffMinutes < 1440) {
                return { status: 'Away', class: 'status-badge-away' };
            } else {
                return { status: 'Inactive', class: 'status-badge-inactive' };
            }
        }
        
        // Priority 3: No login data at all — user was invited but has never signed in
        if (user.accountEnabled) {
            return { status: 'Pending Invite', class: 'status-badge-pending' };
        }
        
        // Default: Disabled
        return { status: 'Disabled', class: 'status-badge-disabled' };
    };

    // Helper: get numeric timestamp for last activity (for sort)
    const getLastActiveTimestamp = (user) => {
        const lastActivity = user.lastActivity || user.last_activity;
        if (lastActivity) return new Date(lastActivity).getTime();
        const lastLogin = user.lastLogin || user.last_login;
        if (lastLogin) return new Date(lastLogin).getTime();
        if (user.signInActivity?.lastSignInDateTime) return new Date(user.signInActivity.lastSignInDateTime).getTime();
        return 0;
    };

    // Sort filtered users based on sortBy (must be after getUserActivityStatus)
    const sortedUsers = [...filteredUsers].sort((a, b) => {
        switch (sortBy) {
            case 'name_asc':
                return (a.displayName || '').localeCompare(b.displayName || '');
            case 'name_desc':
                return (b.displayName || '').localeCompare(a.displayName || '');
            case 'lastActive_desc':
                return getLastActiveTimestamp(b) - getLastActiveTimestamp(a);
            case 'lastActive_asc':
                return getLastActiveTimestamp(a) - getLastActiveTimestamp(b);
            case 'status': {
                const order = { 'Active': 0, 'Away': 1, 'Inactive': 2, 'Never Active': 3, 'Disabled': 4 };
                const sa = getUserActivityStatus(a).status;
                const sb = getUserActivityStatus(b).status;
                return (order[sa] ?? 5) - (order[sb] ?? 5);
            }
            case 'role_asc':
                return (a.role || 'viewer').localeCompare(b.role || 'viewer');
            default:
                return 0;
        }
    });

    // Pagination calculations
    const totalPages = Math.ceil(sortedUsers.length / usersPerPage);
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = sortedUsers.slice(indexOfFirstUser, indexOfLastUser);

    const formatLastActive = (user) => {
        // Priority 1: Use last_activity (tracks any API call)
        const lastActivity = user.lastActivity || user.last_activity;
        
        if (lastActivity) {
            const activityDate = new Date(lastActivity);
            const now = new Date();
            const diffMs = now - activityDate;
            const diffMins = Math.floor(diffMs / 60000);
            const diffHours = Math.floor(diffMs / 3600000);
            const diffDays = Math.floor(diffMs / 86400000);
            
            // Show in minutes/hours if less than 24 hours
            if (diffMins < 1) {
                return 'Just now';
            } else if (diffMins < 60) {
                return `${diffMins} min${diffMins !== 1 ? 's' : ''} ago`;
            } else if (diffHours < 24) {
                return `${diffHours} hr${diffHours !== 1 ? 's' : ''} ago`;
            } else {
                // Show in days for anything over 24 hours
                return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
            }
        }
        
        // Priority 2: Fallback to last_login if no activity tracked yet
        const lastLogin = user.lastLogin || user.last_login;
        if (lastLogin) {
            const lastLoginDate = new Date(lastLogin);
            const now = new Date();
            const diffMs = now - lastLoginDate;
            const diffMins = Math.floor(diffMs / 60000);
            const diffHours = Math.floor(diffMs / 3600000);
            const diffDays = Math.floor(diffMs / 86400000);
            
            if (diffMins < 1) {
                return 'Just now';
            } else if (diffMins < 60) {
                return `${diffMins} min${diffMins !== 1 ? 's' : ''} ago`;
            } else if (diffHours < 24) {
                return `${diffHours} hr${diffHours !== 1 ? 's' : ''} ago`;
            } else {
                return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
            }
        }
        
        // Priority 3: Fallback to Azure AD sign-in activity
        if (user.signInActivity?.lastSignInDateTime) {
            const lastSignIn = new Date(user.signInActivity.lastSignInDateTime);
            const now = new Date();
            const diffMs = now - lastSignIn;
            const diffMins = Math.floor(diffMs / 60000);
            const diffHours = Math.floor(diffMs / 3600000);
            const diffDays = Math.floor(diffMs / 86400000);
            
            if (diffMins < 1) {
                return 'Just now';
            } else if (diffMins < 60) {
                return `${diffMins} min${diffMins !== 1 ? 's' : ''} ago`;
            } else if (diffHours < 24) {
                return `${diffHours} hr${diffHours !== 1 ? 's' : ''} ago`;
            } else {
                return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
            }
        }
        
        // If no activity data available, user has never logged in
        return 'Never';
    };

    const handleEditUser = (user) => {
        setSelectedUser(user);
        setShowEditUserModal(true);
    };

    const handleDeleteUser = (user) => {
        setUserToDelete(user);
        setShowDeleteConfirm(true);
    };

    const confirmDeleteUser = async () => {
        if (!userToDelete) return;

        // azureOid column stores the Firebase UID (sub claim) for TTAuth users.
        // For SSO/federated users it may be null if the user has never signed in.
        const uid = userToDelete.azureOid;
        const email = userToDelete.mail || userToDelete.userPrincipalName;

        if (!uid) {
            alert(
                `Cannot delete "${userToDelete.displayName}" — their account ID is not yet available in the database.\n\n` +
                `This usually means the user record was created before TTAuth was in place, or the user has never signed in.\n\n` +
                `If the user exists in TTAuth, ask them to sign in once so their account ID is recorded, then try again.`
            );
            return;
        }

        setLoading(true);
        try {
            // Pass the Firebase UID in the URL and the email as a query param
            // so the server can remove the record from both TTAuth and the local DB.
            await axios.delete(
                `${config.apiUrl}/api/admin/delete-azure-user/${uid}`,
                { params: { email } }
            );
            setShowDeleteConfirm(false);
            setUserToDelete(null);
            fetchUsers(); // Refresh list
        } catch (error) {
            console.error('Error deleting user:', error);
            alert(`Failed to delete user: ${error.response?.data?.details || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const cancelDeleteUser = () => {
        setShowDeleteConfirm(false);
        setUserToDelete(null);
    };

    const handleBulkImport = () => {
        setShowBulkImportModal(true);
        setBulkImportFile(null);
        setBulkImportData([]);
        setBulkImportErrors([]);
        setBulkImportSuccess('');
    };

    const handleDownloadTemplate = () => {
        // Create CSV content with headers
        const headers = ['Display Name', 'Email Address', 'Account Enabled (true/false)', 'Send Invitation (true/false)'];
        const sampleData = [
            ['John Doe', 'john.doe@example.com', 'true', 'true'],
            ['Jane Smith', 'jane.smith@example.com', 'true', 'true']
        ];
        
        const csvContent = [
            headers.join(','),
            ...sampleData.map(row => row.join(','))
        ].join('\n');
        
        // Create blob and download
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'bulk_user_import_template.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setBulkImportFile(file);
        setBulkImportErrors([]);
        setBulkImportSuccess('');

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const text = e.target.result;
                const lines = text.split('\n').filter(line => line.trim());
                
                if (lines.length < 2) {
                    setBulkImportErrors(['File is empty or has no data rows']);
                    return;
                }

                // Skip header row
                const dataRows = lines.slice(1);
                const parsedData = [];
                const errors = [];

                dataRows.forEach((line, index) => {
                    const values = line.split(',').map(v => v.trim().replace(/^"|"$/g, ''));
                    
                    if (values.length < 2) {
                        errors.push(`Row ${index + 2}: Invalid format - missing required fields`);
                        return;
                    }

                    const [displayName, email, accountEnabled, sendInvitation] = values;
                    
                    // Validation — name
                    if (!displayName || !displayName.trim()) {
                        errors.push(`Row ${index + 2}: Display Name is required`);
                    } else if (displayName.trim().length < 2) {
                        errors.push(`Row ${index + 2}: Display Name must be at least 2 characters`);
                    } else if (displayName.trim().length > 100) {
                        errors.push(`Row ${index + 2}: Display Name must be 100 characters or fewer`);
                    } else if (!/^[\p{L}\p{M}'\-. ]+$/u.test(displayName.trim())) {
                        errors.push(`Row ${index + 2}: Display Name "${displayName}" contains invalid characters — only letters, spaces, hyphens, apostrophes, and dots are allowed`);
                    }

                    // Validation — email
                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (!email || !email.trim()) {
                        errors.push(`Row ${index + 2}: Email address is required`);
                    } else if (!emailRegex.test(email.trim())) {
                        errors.push(`Row ${index + 2}: "${email}" is not a valid email address`);
                    }

                    parsedData.push({
                        displayName: displayName || '',
                        userPrincipalName: email || '',
                        accountEnabled: accountEnabled?.toLowerCase() !== 'false',
                        sendInvitationMessage: sendInvitation?.toLowerCase() !== 'false',
                        userType: 'GuestInvite'
                    });
                });

                setBulkImportData(parsedData);
                setBulkImportErrors(errors);
            } catch (error) {
                setBulkImportErrors(['Error parsing file: ' + error.message]);
            }
        };
        
        reader.readAsText(file);
    };

    const handleBulkCreateUsers = async () => {
        if (bulkImportData.length === 0) {
            setBulkImportErrors(['No valid data to import']);
            return;
        }

        if (bulkImportErrors.length > 0) {
            alert('Please fix all errors before proceeding');
            return;
        }

        setBulkImportLoading(true);
        setBulkImportSuccess('');
        
        try {
            const results = {
                success: [],
                failed: [],
                skipped: []
            };

            // Get current users to check for duplicates
            const existingUsers = users.map(u => (u.mail || u.userPrincipalName).toLowerCase());

            // Create users one by one
            for (let i = 0; i < bulkImportData.length; i++) {
                const userData = bulkImportData[i];
                const userEmail = userData.userPrincipalName.toLowerCase();
                
                // Check if user already exists
                if (existingUsers.includes(userEmail)) {
                    results.skipped.push(`Row ${i + 2}: ${userData.displayName} (${userData.userPrincipalName}) - Already exists`);
                    continue;
                }
                
                try {
                    await axios.post(`${config.apiUrl}/api/admin/create-azure-user`, userData);
                    results.success.push(`Row ${i + 2}: ${userData.displayName} (${userData.userPrincipalName})`);
                    // Add to existing users list to prevent duplicates within the same batch
                    existingUsers.push(userEmail);
                } catch (error) {
                    const errorMsg = error.response?.data?.details || error.message;
                    // Check if error is due to user already existing
                    if (errorMsg.includes('already exists') || errorMsg.includes('already taken')) {
                        results.skipped.push(`Row ${i + 2}: ${userData.displayName} (${userData.userPrincipalName}) - Already exists`);
                    } else {
                        results.failed.push(`Row ${i + 2}: ${userData.displayName} - ${errorMsg}`);
                    }
                }
            }

            // Show results
            let resultMessage = '';
            
            if (results.success.length > 0) {
                resultMessage += `✅ Successfully created ${results.success.length} user(s)\n${results.success.join('\n')}\n\n`;
            }
            
            if (results.skipped.length > 0) {
                resultMessage += `⏭️ Skipped ${results.skipped.length} existing user(s)\n${results.skipped.join('\n')}\n\n`;
            }

            if (results.success.length > 0 || results.skipped.length > 0) {
                setBulkImportSuccess(resultMessage.trim());
                if (results.success.length > 0) {
                    fetchUsers(); // Refresh user list only if new users were created
                }
            }
            
            if (results.failed.length > 0) {
                setBulkImportErrors(results.failed);
            } else if (results.success.length > 0) {
                // If all succeeded (and none failed), close modal after a delay
                setTimeout(() => {
                    setShowBulkImportModal(false);
                }, 3000);
            }
        } catch (error) {
            setBulkImportErrors(['Bulk import failed: ' + error.message]);
        } finally {
            setBulkImportLoading(false);
        }
    };

    const closeBulkImportModal = () => {
        setShowBulkImportModal(false);
        setBulkImportFile(null);
        setBulkImportData([]);
        setBulkImportErrors([]);
        setBulkImportSuccess('');
    };

    const handleAddUser = () => {
        setNewUserData({
            displayName: '',
            userPrincipalName: '',
            accountEnabled: true,
            userType: 'GuestInvite',
            sendInvitationMessage: true
        });
        setUserFormError('');
        setUserFormSuccess('');
        setShowAddUserModal(true);
    };

    const handleCloseModal = () => {
        setShowAddUserModal(false);
        setShowEditUserModal(false);
        setSelectedUser(null);
        setUserFormError('');
        setUserFormSuccess('');
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewUserData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Validation helpers
    const validateDisplayName = (name) => {
        if (!name || !name.trim()) return 'Display name is required.';
        if (name.trim().length < 2) return 'Display name must be at least 2 characters.';
        if (name.trim().length > 100) return 'Display name must be 100 characters or fewer.';
        // Allow letters (including accented/unicode), spaces, hyphens, apostrophes, and dots
        if (!/^[\p{L}\p{M}'\-. ]+$/u.test(name.trim())) {
            return 'Display name may only contain letters, spaces, hyphens (-), apostrophes (\'), and dots (.).';
        }
        return null;
    };

    const validateEmail = (email) => {
        if (!email || !email.trim()) return 'Email address is required.';
        // RFC-5321 inspired pattern: local@domain.tld
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email.trim())) return 'Please enter a valid email address (e.g. john.doe@example.com).';
        return null;
    };

    const handleCreateUser = async (e) => {
        e.preventDefault();
        setUserFormError('');
        setUserFormSuccess('');

        // Client-side validation
        const nameError = validateDisplayName(newUserData.displayName);
        if (nameError) { setUserFormError(nameError); return; }

        const emailError = validateEmail(newUserData.userPrincipalName);
        if (emailError) { setUserFormError(emailError); return; }

        setLoading(true);

        try {
            const response = await axios.post(`${config.apiUrl}/api/admin/create-azure-user`, newUserData);
            console.log('[CREATE USER] Full response status:', response.status);
            console.log('[CREATE USER] Full response data:', JSON.stringify(response.data, null, 2));
            
            if (response.data.success) {
                setUserFormSuccess(`User ${newUserData.displayName} created successfully!`);
                setTimeout(() => {
                    handleCloseModal();
                    fetchUsers(); // Refresh list
                }, 2000);
            } else {
                console.warn('[CREATE USER] Response did not have success=true:', response.data);
                setUserFormError('Server responded but did not confirm success. Check console for details.');
            }
        } catch (error) {
            console.error('[CREATE USER] Error creating user:', error);
            console.error('[CREATE USER] Error response status:', error.response?.status);
            console.error('[CREATE USER] Error response data:', JSON.stringify(error.response?.data, null, 2));
            console.error('[CREATE USER] Error message:', error.message);
            setUserFormError(error.response?.data?.details || error.response?.data?.error || 'Failed to create user. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateUserRole = async (user, newRole) => {
        if (loading) return;
        
        setLoading(true);
        try {
            const userEmail = user.mail || user.userPrincipalName;
            const response = await axios.post(`${config.apiUrl}/api/admin/update-user-role`, {
                email: userEmail,
                role: newRole
            });

            if (response.data.success) {
                fetchUsers(); // Refresh list
            }
        } catch (error) {
            console.error('Error updating user role:', error);
            alert(`Failed to update user role: ${error.response?.data?.details || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    // Databricks Overview — reuses the already-loaded spnGenieMap data so the
    // count always matches the SPN-Genies tab (union of SCIM + secrets-discovered).
    const fetchDatabricksOverview = async () => {
        setDatabricksLoading(true);
        setDatabricksError('');
        try {
            // If the SPN-Genie map has already been loaded, reuse it directly
            // to avoid a redundant network call and ensure counts are consistent.
            if (spnGenieMap.length > 0) {
                setDatabricksSpns(spnGenieMap.map(s => ({ id: s.scimId || '', displayName: s.name })));
                setDatabricksGenieSpaces(spnGenieAllSpaces);
                setDatabricksHost(spnGenieHost);
                return;
            }
            // Fallback: fetch fresh data from the same spn-genie-map endpoint
            const response = await axios.get(`${config.apiUrl}/api/admin/spn-genie-map`);
            const spns = (response.data.spns || []).map(s => ({ id: s.scimId || '', displayName: s.name }));
            setDatabricksSpns(spns);
            setDatabricksGenieSpaces(response.data.genieSpaces || []);
            setDatabricksHost(response.data.host || '');
        } catch (error) {
            setDatabricksError(error.response?.data?.details || error.message || 'Failed to fetch Databricks data');
        } finally {
            setDatabricksLoading(false);
        }
    };

    // ── SPN-Genies tab functions ──────────────────────────────────────────────

    const fetchSpnGenieMap = useCallback(async () => {
        setSpnGenieLoading(true);
        setSpnGenieError('');
        try {
            const hostsParam = selectedDatabricksHosts.join(',');
            const response = await axios.get(`${config.apiUrl}/api/admin/spn-genie-map?hosts=${hostsParam}`);
            setSpnGenieMap(response.data.spns || []);
            setSpnGenieAllSpaces(response.data.genieSpaces || []);
            setSpnGenieHost(response.data.host || response.data.hosts?.join(', ') || '');
            // Invalidate the overview cache so it re-derives from the fresh data next open
            setDatabricksSpns([]);
        } catch (error) {
            setSpnGenieError(error.response?.data?.details || error.message || 'Failed to fetch SPN-Genie map');
        } finally {
            setSpnGenieLoading(false);
        }
    }, [selectedDatabricksHosts]);
    
    // Re-fetch when the selected hosts change
    useEffect(() => {
        if (activeTab === 'spn-genies') {
            fetchSpnGenieMap();
        }
    }, [selectedDatabricksHosts, activeTab, fetchSpnGenieMap]);

    const openAddGenieModal = (spn) => {
        setAddGenieTarget(spn);
        setAddGenieSearch('');
        setAddGenieError('');
        setShowAddGenieModal(true);
    };

    const closeAddGenieModal = () => {
        setShowAddGenieModal(false);
        setAddGenieTarget(null);
        setAddGenieSearch('');
        setAddGenieError('');
    };

    const handleAddGenie = async (genieId) => {
        if (!addGenieTarget) return;
        setAddGenieSaving(true);
        setAddGenieError('');
        try {
            const workspace = (addGenieTarget.workspaces && addGenieTarget.workspaces.length > 0)
                ? addGenieTarget.workspaces[0]
                : 'LOCAL_DATABRICKS_HOST';
            await axios.put(`${config.apiUrl}/api/admin/spn-genie-map/${encodeURIComponent(addGenieTarget.name)}/genie/${encodeURIComponent(genieId)}?workspace=${encodeURIComponent(workspace)}`);
            // Optimistically update local state
            setSpnGenieMap(prev => prev.map(spn => {
                if (spn.name !== addGenieTarget.name) return spn;
                if (spn.genieIds && spn.genieIds.includes(genieId)) return spn;
                const space = spnGenieAllSpaces.find(s => s.id === genieId);
                const newGenie = { id: genieId, title: space ? space.title : '(name unknown)' };
                return {
                    ...spn,
                    genieIds: [...(spn.genieIds || []), genieId],
                    genies: [...(spn.genies || []), newGenie]
                };
            }));
            // Update addGenieTarget too so the checkmarks update immediately
            setAddGenieTarget(prev => {
                if (!prev) return prev;
                const space = spnGenieAllSpaces.find(s => s.id === genieId);
                const newGenie = { id: genieId, title: space ? space.title : '(name unknown)' };
                return {
                    ...prev,
                    genieIds: [...(prev.genieIds || []), genieId],
                    genies: [...(prev.genies || []), newGenie]
                };
            });
        } catch (error) {
            setAddGenieError(error.response?.data?.details || error.message || 'Failed to add Genie Space');
        } finally {
            setAddGenieSaving(false);
        }
        // Notify GenieContext to refresh its genie list
        window.dispatchEvent(new Event('genieMapChanged'));
    };

    const handleRemoveGenie = async (spnName, genieId) => {
        try {
            const spn = spnGenieMap.find(s => s.name === spnName);
            const workspace = (spn && spn.workspaces && spn.workspaces.length > 0)
                ? spn.workspaces[0]
                : 'LOCAL_DATABRICKS_HOST';
            await axios.delete(`${config.apiUrl}/api/admin/spn-genie-map/${encodeURIComponent(spnName)}/genie/${encodeURIComponent(genieId)}?workspace=${encodeURIComponent(workspace)}`);
            setSpnGenieMap(prev => prev.map(spn => {
                if (spn.name !== spnName) return spn;
                return {
                    ...spn,
                    genieIds: (spn.genieIds || []).filter(id => id !== genieId),
                    genies: (spn.genies || []).filter(g => g.id !== genieId)
                };
            }));
            // Notify GenieContext to refresh its genie list
            window.dispatchEvent(new Event('genieMapChanged'));
        } catch (error) {
            alert(`Failed to remove Genie Space: ${error.response?.data?.details || error.message}`);
        }
    };

    const handleTestGenie = async (spn) => {
        setTestGenieTarget(spn);
        setTestGenieResults(null);
        setTestGenieError('');
        setShowTestGenieModal(true);
        setTestGenieLoading(true);
        try {
            // Determine which workspace this SPN belongs to so the server queries
            // the correct Databricks instance for secrets. Default to LOCAL if unknown.
            const workspace = (spn.workspaces && spn.workspaces.length > 0)
                ? spn.workspaces[0]
                : 'LOCAL_DATABRICKS_HOST';
            const response = await axios.post(
                `${config.apiUrl}/api/admin/spn-genie-map/${encodeURIComponent(spn.name)}/test?workspace=${encodeURIComponent(workspace)}`
            );
            setTestGenieResults(response.data);
        } catch (error) {
            setTestGenieError(error.response?.data?.details || error.message || 'Test request failed');
        } finally {
            setTestGenieLoading(false);
        }
    };

    const closeTestGenieModal = () => {
        setShowTestGenieModal(false);
        setTestGenieTarget(null);
        setTestGenieResults(null);
        setTestGenieError('');
        setTestGenieLoading(false);
    };

    // SPN Management Functions
    const fetchSpnData = async () => {
        setSpnLoading(true);
        try {
            const [usersRes, spnsRes] = await Promise.all([
                axios.get(`${config.apiUrl}/api/admin/users`),
                axios.get(`${config.apiUrl}/api/admin/spns`)
            ]);
       
            setSpnUsers(usersRes.data || []);
            setAllSpns(spnsRes.data || []);
        } catch (error) {
            console.error('[ADMIN] Error fetching SPN data:', error);
            console.error('[ADMIN] Error details:', error.response?.data);
        } finally {
            setSpnLoading(false);
        }
    };

    const handleSyncDatabricksSpns = async () => {
        setSpnLoading(true);
        try {
            const response = await axios.post(`${config.apiUrl}/api/admin/fetch-databricks-spns`);
            
            // Wait a moment for database to settle
            await new Promise(resolve => setTimeout(resolve, 500));
            
            // Fetch SPNs again to update the UI
            await fetchSpnData();
            
            alert(response.data.message || 'SPNs synced successfully');
        } catch (error) {
            console.error('[ADMIN] Error syncing Databricks SPNs:', error);
            console.error('[ADMIN] Error response:', error.response?.data);
            const errorMessage = error.response?.data?.details || error.response?.data?.error || error.message;
            alert(`Failed to sync SPNs: ${errorMessage}\n\nCheck browser console for details.`);
        } finally {
            setSpnLoading(false);
        }
    };

    // Role Modal Functions
    // const handleAddRole = () => { // Removed - not used
    //     setEditingRole(null);
    //     setRoleFormData({
    //         name: '',  // Will be the user email selected from dropdown
    //         features: []
    //     });
    //     setShowRoleModal(true);
    // };

    // Get existing SPNs for the selected user
    const getExistingSpnsForUser = (userEmail) => {
        if (!userEmail) return [];
        const user = spnUsers.find(u => u.email === userEmail);
        return user?.spns || [];
    };

    // const handleEditRole = (user) => { // Removed - not used
    //     setEditingRole(user);
    //     setRoleFormData({
    //         name: user.display_name || user.email,
    //         features: user.spns || []
    //     });
    //     setShowRoleModal(true);
    // };

    const handleCloseRoleModal = () => {
        setShowRoleModal(false);
        setEditingRole(null);
        setSelectedClient(null);
        setRoleFormData({
            name: '',
            features: []
        });
    };

    const handleFeatureToggle = (featureName, isExisting = false) => {
        // Prevent toggling if it's an existing SPN
        if (isExisting) return;
        
        setRoleFormData(prev => {
            const features = prev.features.includes(featureName)
                ? prev.features.filter(f => f !== featureName)
                : [...prev.features, featureName];
            return { ...prev, features };
        });
    };

    // Handle user selection in Add Role modal
    const handleUserSelection = (userEmail) => {
        const existingSpns = getExistingSpnsForUser(userEmail);
        setRoleFormData({
            name: userEmail,
            features: [...existingSpns]  // Pre-populate with existing SPNs
        });
    };

    const handleSaveRole = async () => {
        // Check if we're editing a client (via selectedClient) or a user
        if (selectedClient) {
            // Use the client feature save function
            return handleSaveClientFeatures();
        }

        if (!roleFormData.name.trim()) {
            alert('Please enter a role name');
            return;
        }

        setSpnLoading(true);
        try {
            // For now, we'll update the user's assigned SPNs
            // In a real implementation, you'd create/update a role entity
            const userEmail = editingRole?.email || roleFormData.name;
            
            // Remove old SPNs and add new ones
            if (editingRole) {
                // Remove all old SPNs
                for (const spn of editingRole.spns || []) {
                    if (!roleFormData.features.includes(spn)) {
                        await axios.post(`${config.apiUrl}/api/admin/remove-spn`, {
                            user: userEmail,
                            spn: spn
                        });
                    }
                }
                
                // Add new SPNs
                for (const feature of roleFormData.features) {
                    if (!(editingRole.spns || []).includes(feature)) {
                        await axios.post(`${config.apiUrl}/api/admin/assign-spn`, {
                            user: userEmail,
                            spn: feature
                        });
                    }
                }
            }
            
            alert(`Role ${editingRole ? 'updated' : 'created'} successfully`);
            handleCloseRoleModal();
            fetchSpnData();
        } catch (error) {
            console.error('Error saving role:', error);
            alert(`Failed to save role: ${error.response?.data?.details || error.message}`);
        } finally {
            setSpnLoading(false);
        }
    };

    // ============================================================================
    // CLIENT MANAGEMENT FUNCTIONS
    // ============================================================================

    const fetchClients = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${config.apiUrl}/api/admin/clients`);
            setClients(response.data || []);
        } catch (error) {
            console.error('[ADMIN] Error fetching clients:', error);
            setClients([]);
        } finally {
            setLoading(false);
        }
    };

    // Fetch client mappings only for currently visible users (page-wise optimization)
    const fetchUserClientsForCurrentPage = async () => {
        setLoadingClients(true);
        try {
            // Compute the current page slice inline (cannot use render-time currentUsers here)
            const currentFilteredUsers = users.filter(user => {
                const matchesSearch = user.displayName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                    user.mail?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                    user.userPrincipalName?.toLowerCase().includes(searchQuery.toLowerCase());
                const matchesRole = filterRole === 'all' || user.role === filterRole;
                return matchesSearch && matchesRole;
            });
            const idxLast = currentPage * usersPerPage;
            const idxFirst = idxLast - usersPerPage;
            const pageUsers = currentFilteredUsers.slice(idxFirst, idxLast);

            // Get emails of currently visible users
            const visibleEmails = pageUsers.map(user => user.mail || user.userPrincipalName);
            
            // Check which users we don't have data for yet
            const emailsToFetch = visibleEmails.filter(email => !(email in userClientsMap));
            
            if (emailsToFetch.length === 0) {
                // We already have all the data for visible users
                setLoadingClients(false);
                return;
            }
            
            
            // Fetch clients for these specific users in parallel
            const promises = emailsToFetch.map(email =>
                axios.get(`${config.apiUrl}/api/admin/users/${email}/clients`)
                    .then(response => ({ email, clients: response.data.clients || [] }))
                    .catch(error => {
                        console.error(`[ADMIN] Error fetching clients for ${email}:`, error);
                        return { email, clients: [] };
                    })
            );
            
            const results = await Promise.all(promises);
            
            // Update state with new data
            setUserClientsMap(prev => {
                const updated = { ...prev };
                results.forEach(({ email, clients }) => {
                    updated[email] = clients;
                });
                return updated;
            });
            
        } catch (error) {
            console.error('[ADMIN] Error fetching user clients for page:', error);
        } finally {
            setLoadingClients(false);
        }
    };

    const handleAddClient = () => {
        setNewClientData({ name: '', description: '' });
        setShowAddClientModal(true);
    };

    const handleEditClient = (client) => {
        setSelectedClient(client);
        setNewClientData({
            name: client.name,
            description: client.description || ''
        });
        setShowEditClientModal(true);
    };

    const handleDeleteClient = async (clientName) => {
        if (!window.confirm(`Are you sure you want to delete client "${clientName}"?`)) {
            return;
        }

        setLoading(true);
        try {
            await axios.delete(`${config.apiUrl}/api/admin/clients/${clientName}`);
            fetchClients();
        } catch (error) {
            console.error('[ADMIN] Error deleting client:', error);
            alert(`Failed to delete client: ${error.response?.data?.details || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateClient = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axios.post(`${config.apiUrl}/api/admin/clients`, newClientData);
            setShowEditClientModal(false);
            setSelectedClient(null);
            setNewClientData({ name: '', description: '' });
            fetchClients();
        } catch (error) {
            console.error('[ADMIN] Error creating client:', error);
            alert(`Failed to create client: ${error.response?.data?.details || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateClient = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axios.put(`${config.apiUrl}/api/admin/clients/${selectedClient.name}`, newClientData);
            setShowEditClientModal(false);
            setSelectedClient(null);
            setNewClientData({ name: '', description: '' });
            fetchClients();
        } catch (error) {
            console.error('[ADMIN] Error updating client:', error);
            alert(`Failed to update client: ${error.response?.data?.details || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleAssignClientToUser = (user) => {
        setSelectedUserForClient(user);
        setShowClientAssignModal(true);
    };

    const handleClientAssignment = async (clientName, action) => {
        // Support both edit modal (selectedUser) and assignment modal (selectedUserForClient)
        const user = selectedUser || selectedUserForClient;
        if (!user) return;

        const email = user.mail || user.userPrincipalName;
        
        // Get current state before making changes
        const currentClients = userClientsMap[email] || [];
        
        // Optimistic UI update - update immediately for better UX
        const updatedClients = action === 'add'
            ? [...currentClients, clientName]
            : currentClients.filter(c => c !== clientName);
        
        setUserClientsMap(prev => ({
            ...prev,
            [email]: updatedClients
        }));

        try {
            if (action === 'add') {
                await axios.post(`${config.apiUrl}/api/admin/users/${email}/clients`, { clientName });
            } else if (action === 'remove') {
                await axios.delete(`${config.apiUrl}/api/admin/users/${email}/clients/${clientName}`);
            }
            
            // Verify the change by fetching only this user's clients
            const response = await axios.get(`${config.apiUrl}/api/admin/users/${email}/clients`);
            setUserClientsMap(prev => ({
                ...prev,
                [email]: response.data.clients || []
            }));
            
            // Notify Navbar to refresh clients
            window.dispatchEvent(new Event('clientsUpdated'));
        } catch (error) {
            console.error('[ADMIN] Error managing client assignment:', error);
            alert(`Failed to ${action} client: ${error.response?.data?.details || error.message}`);
            
            // Revert optimistic update on error
            setUserClientsMap(prev => ({
                ...prev,
                [email]: currentClients
            }));
        }
    };
// ============================================================================
    // CLIENT-FEATURE MANAGEMENT FUNCTIONS
    // ============================================================================

    const fetchClientSpns = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}/api/admin/clients-with-spns`);
            
            // Store client SPNs in dedicated state - cleaner separation
            const clientSpnsData = {};
            response.data.forEach(item => {
                const clientName = item.name;
                if (clientName) {
                    clientSpnsData[clientName] = item.spns || [];
                } else {
                    console.warn('[ADMIN] Warning: Client item missing name property:', item);
                }
            });
            
            setClientSpnsMap(clientSpnsData);
        } catch (error) {
            console.error('[ADMIN] Error fetching client SPNs:', error);
        }
    };

    const handleEditClientFeatures = async (client) => {
        setSelectedClient(client);
        // Get current SPNs for this client from dedicated state
        const currentSpns = clientSpnsMap[client.name] || [];
        
        // Fetch client's assigned Power BI dashboards
        const assignedDashboards = await fetchClientDashboards(client.name);
        
        
        // Include assigned dashboard IDs in features
        const features = [...currentSpns, ...assignedDashboards];
        
        setRoleFormData({
            name: client.name,
            features: features
        });
        setShowRoleModal(true);
    };

    const handleSaveClientFeatures = async () => {
        if (!selectedClient) {
            alert('No client selected');
            return;
        }

        setSpnLoading(true);
        try {
            
            // Separate features: PowerBI dashboards, Databricks dashboards, regular SPNs
            const databricksIds = new Set(availableDatabricksDashboards.map(d => d.id));
            const powerbiFeatures = roleFormData.features.filter(f => f.startsWith('dashboard_') && !databricksIds.has(f));
            const databricksFeatures = roleFormData.features.filter(f => databricksIds.has(f));
            const regularSpns = roleFormData.features.filter(f => !f.startsWith('dashboard_') && !databricksIds.has(f));

            // Update the client's SPNs
            await axios.put(`${config.apiUrl}/api/admin/clients/${selectedClient.name}/spns`, {
                spns: regularSpns
            });

            // Update Power BI dashboards
            await axios.put(`${config.apiUrl}/api/admin/clients/${selectedClient.name}/powerbi/dashboards`, {
                dashboardIds: powerbiFeatures
            });

            // Update Databricks dashboards
            await axios.put(`${config.apiUrl}/api/admin/clients/${selectedClient.name}/databricks/dashboards`, {
                dashboardIds: databricksFeatures
            });
            
            
            // Close modal first
            handleCloseRoleModal();
            
            // Then refresh the data
            await fetchClientSpns();
            await fetchClientsPowerBIStatus();
            
            
            alert('Client features updated successfully');
        } catch (error) {
            console.error('[ADMIN] Error saving client features:', error);
            console.error('[ADMIN] Error response:', error.response?.data);
            alert(`Failed to save features: ${error.response?.data?.details || error.message}`);
        } finally {
            setSpnLoading(false);
        }
    };

    // ============================================================================
    // POWER BI MANAGEMENT FUNCTIONS
    // ============================================================================

    const fetchClientsPowerBIStatus = async () => {
        // This function is kept for compatibility but no longer stores state
        // It's called during data refresh to ensure backend stays in sync
        try {
            await axios.get(`${config.apiUrl}/api/admin/clients/powerbi/status`);
        } catch (error) {
            console.error('[ADMIN] Error fetching Power BI status:', error);
        }
    };

    const fetchAvailableDashboards = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}/api/admin/powerbi/dashboards`);
            // Only show PowerBI-type dashboards in the PowerBI section
            const pbiOnly = (response.data || []).filter(d => d.type !== 'databricks');
            setAvailableDashboards(pbiOnly);
        } catch (error) {
            console.error('[ADMIN] Error fetching Power BI dashboards:', error);
            setAvailableDashboards([]);
        }
    };

    const fetchAvailableDatabricksDashboards = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}/api/admin/databricks/dashboards`);
            setAvailableDatabricksDashboards(response.data || []);
        } catch (error) {
            console.error('[ADMIN] Error fetching Databricks dashboards:', error);
            setAvailableDatabricksDashboards([]);
        }
    };

    const fetchClientDashboards = async (clientName) => {
        try {
            const response = await axios.get(`${config.apiUrl}/api/admin/clients/${encodeURIComponent(clientName)}/powerbi/dashboards`);
            // Backend returns 'dashboardIds', not 'dashboards'
            return response.data.dashboardIds || [];
        } catch (error) {
            console.error('[ADMIN] Error fetching client dashboards:', error);
            return [];
        }
    };

    // Open PowerBI preview for a specific client + dashboard — passes clientName as URL param
    // so PowerBIDashboard.js uses it for RLS scoping (same pattern as AdminTOSDashboard)
    const handlePreviewClientDashboard = (client, dashboardId, dashboardName) => {
        setSelectedClientForPreview(client);
        navigate(`/powerbi-dashboard?id=${encodeURIComponent(dashboardId)}&name=${encodeURIComponent(dashboardName)}&clientName=${encodeURIComponent(client.name)}`);
    };

    // Load assigned dashboards for a given client into previewDashboards state
    const loadPreviewDashboards = async (client) => {
        setSelectedClientForPreview(client);
        setPreviewLoading(true);
        try {
            const dashboardIds = await fetchClientDashboards(client.name);
            setPreviewDashboards(dashboardIds);
        } catch (err) {
            console.error('[ADMIN] Error loading preview dashboards:', err);
            setPreviewDashboards([]);
        } finally {
            setPreviewLoading(false);
        }
    };

    // const handleTogglePowerBI = async (clientName, currentStatus) => { // Removed - not used
    //     const action = currentStatus ? 'disable' : 'enable';
    //
    //     if (!window.confirm(`Are you sure you want to ${action} Power BI access for "${clientName}"?`)) {
    //         return;
    //     }
    //
    //     setLoading(true);
    //     try {
    //         await axios.post(`${config.apiUrl}/api/admin/clients/${clientName}/powerbi/${action}`);
    //         console.log(`[ADMIN] Power BI ${action}d for client:`, clientName);
    //
    //         // Refresh the status
    //         await fetchClientsPowerBIStatus();
    //
    //     } catch (error) {
    //         console.error(`[ADMIN] Error ${action}ing Power BI:`, error);
    //         alert(`Failed to ${action} Power BI access: ${error.response?.data?.details || error.message}`);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    return (
        <div className="admin-container">
            {/* Sidebar */}
            <div className="admin-sidebar">
                <div className="sidebar-header">
                    <button
                        className="back-arrow-btn"
                        onClick={() => navigate(-1)}
                        title="Go back"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
                <nav className="sidebar-nav">
                    <button
                        className={`sidebar-tab ${activeTab === 'users' ? 'active' : ''}`}
                        onClick={() => setActiveTab('users')}
                    >
                        Users
                    </button>
                    <button
                        className={`sidebar-tab ${activeTab === 'roles' ? 'active' : ''}`}
                        onClick={() => setActiveTab('roles')}
                    >
                        Roles
                    </button>
                    <button
                        className={`sidebar-tab ${activeTab === 'spn-genies' ? 'active' : ''}`}
                        onClick={() => setActiveTab('spn-genies')}
                    >
                        SPN-Genies
                    </button>
                </nav>
            </div>

            {/* Main Content */}
            <div className="admin-main">
                {activeTab === 'users' && (
                    <>
                        <div className="admin-header">
                            <h1>Users</h1>
                            <p className="admin-subtitle">Manage users and permissions for Data Studio</p>
                        </div>

                        {/* Search and Actions */}
                        <div className="admin-actions">
                            <div className="search-container">
                                <svg className="search-icon-admin" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zM16 16l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="admin-search-input"
                                />
                            </div>
                            <div className="filter-dropdown" style={{position: 'relative'}}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#666', pointerEvents: 'none', zIndex: 1}}>
                                    <path d="M2 4h12M4 8h8M6 12h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                <select
                                    value={filterRole}
                                    onChange={(e) => setFilterRole(e.target.value)}
                                    className="admin-filter-select"
                                    style={{paddingLeft: '36px'}}
                                >
                                    <option value="all">Filter</option>
                                    <option value="admin">Admin</option>
                                    <option value="viewer">Viewer</option>
                                </select>
                            </div>
                            <button className="btn-bulk-import" onClick={handleBulkImport}>
                                Bulk Import
                            </button>
                            <button className="btn-bulk-import" onClick={handleAddClient}>
                                Manage Clients
                            </button>
                            <button className="btn-add-user" onClick={handleAddUser}>
                                + Add User
                            </button>
                            {/* Sort control pushed to the right corner */}
                            <div className="sort-dropdown" style={{position: 'relative', marginLeft: 'auto'}}>
                                {/* Up-down arrows sort icon — distinct from the filter icon */}
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#666', pointerEvents: 'none', zIndex: 1}}>
                                    <path d="M4 2v12M4 14l-2-2M4 14l2-2M12 14V2M12 2l-2 2M12 2l2 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <select
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                    className="admin-filter-select"
                                    style={{paddingLeft: '36px'}}
                                    title="Sort users"
                                >
                                    <option value="lastActive_desc">Last Active ↓</option>
                                    <option value="lastActive_asc">Last Active ↑</option>
                                    <option value="name_asc">Name A → Z</option>
                                    <option value="name_desc">Name Z → A</option>
                                    <option value="status">Status</option>
                                    <option value="role_asc">Role</option>
                                </select>
                            </div>
                        </div>

                        {/* Users Table */}
                        <div className="admin-table-container">
                            {loading ? (
                                <div className="loading-state">Loading users...</div>
                            ) : filteredUsers.length === 0 ? (
                                <div className="loading-state">No users found</div>
                            ) : (
                                <>
                                    <table className="admin-table">
                                        <thead>
                                            <tr>
                                                <th>User</th>
                                                <th></th>
                                                <th>Username</th>
                                                <th>Role</th>
                                                <th>Clients</th>
                                                <th>Status</th>
                                                <th>Last Active</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentUsers.map((user) => (
                                            <tr key={user.id}>
                                                <td>
                                                    <div className="user-avatar">
                                                        {user.displayName?.charAt(0) || 'U'}
                                                    </div>
                                                </td>
                                                <td className="user-name">{user.displayName || 'N/A'}</td>
                                                <td className="user-email">{user.mail || user.userPrincipalName}</td>
                                                <td>
                                                    <span className={`role-badge ${getRoleBadgeClass(user.role || 'viewer')}`}>
                                                        {getRoleDisplayName(user.role || 'viewer')}
                                                    </span>
                                                </td>
                                                <td>
                                                    {loadingClients ? (
                                                        <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                                                            <div className="skeleton-loader" style={{
                                                                width: '60px',
                                                                height: '20px',
                                                                borderRadius: '4px',
                                                                background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                backgroundSize: '200% 100%',
                                                                animation: 'shimmer 1.5s infinite'
                                                            }}></div>
                                                        </div>
                                                    ) : (() => {
                                                        const email = user.mail || user.userPrincipalName;
                                                        let assignedClients = userClientsMap[email] || [];
                                                        
                                                        // Convert string to array if needed (clients column is TEXT, comma-separated)
                                                        if (typeof assignedClients === 'string') {
                                                            assignedClients = assignedClients ? assignedClients.split(',').map(c => c.trim()).filter(c => c) : [];
                                                        }
                                                        
                                                        return assignedClients.length > 0 ? (
                                                            <div className="role-features" style={{display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                                                                {assignedClients.slice(0, 2).map(clientName => (
                                                                    <span key={clientName} className="feature-badge" style={{fontSize: '11px'}}>
                                                                        {clientName}
                                                                    </span>
                                                                ))}
                                                                {assignedClients.length > 2 && (
                                                                    <span className="feature-badge" style={{fontSize: '11px', cursor: 'pointer'}}
                                                                        onClick={() => handleAssignClientToUser(user)}
                                                                        title={`+${assignedClients.length - 2} more clients`}>
                                                                        +{assignedClients.length - 2}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <span style={{color: '#8E8E93', fontSize: '12px', cursor: 'pointer'}}
                                                                onClick={() => handleAssignClientToUser(user)}>
                                                                None
                                                            </span>
                                                        );
                                                    })()}
                                                </td>
                                                <td>
                                                    {(() => {
                                                        const statusInfo = getUserActivityStatus(user);
                                                        return (
                                                            <span className={`status-badge ${statusInfo.class}`}>
                                                                {statusInfo.status}
                                                            </span>
                                                        );
                                                    })()}
                                                </td>
                                                <td className="last-active">{formatLastActive(user)}</td>
                                                <td className="action-icons">
                                                    <button
                                                        className="icon-btn edit-btn"
                                                        onClick={() => handleEditUser(user)}
                                                        title="Edit user"
                                                    >
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M11.333 2A2.827 2.827 0 0 1 14 4.667L12.667 6 10 3.333 11.333 2zM2 14h2.667L12 6.667 9.333 4 2 11.333V14z" fill="currentColor"/>
                                                        </svg>
                                                    </button>
                                                    <button
                                                        className="icon-btn delete-btn"
                                                        onClick={() => handleDeleteUser(user)}
                                                        title="Delete user"
                                                    >
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 0 1 1.334-1.334h2.666a1.333 1.333 0 0 1 1.334 1.334V4m2 0v9.333a1.333 1.333 0 0 1-1.334 1.334H4.667a1.333 1.333 0 0 1-1.334-1.334V4h9.334z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/* Pagination Controls */}
                                <div className="pagination-container" style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '20px',
                                    borderTop: '1px solid #E5E5EA',
                                    marginTop: '0'
                                }}>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                                        <span style={{fontSize: '14px', color: '#8E8E93'}}>Rows per page:</span>
                                        <select
                                            value={usersPerPage}
                                            onChange={handleUsersPerPageChange}
                                            style={{
                                                padding: '6px 12px',
                                                borderRadius: '6px',
                                                border: '1px solid #E5E5EA',
                                                fontSize: '14px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>
                                        <span style={{fontSize: '14px', color: '#8E8E93', marginLeft: '12px'}}>
                                             Showing {indexOfFirstUser + 1}-{Math.min(indexOfLastUser, sortedUsers.length)} of {sortedUsers.length} users
                                        </span>
                                    </div>

                                    <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                                        <button
                                            onClick={() => handlePageChange(1)}
                                            disabled={currentPage === 1}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '6px',
                                                border: '1px solid #E5E5EA',
                                                backgroundColor: currentPage === 1 ? '#F9F9F9' : '#fff',
                                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                opacity: currentPage === 1 ? 0.5 : 1,
                                                fontSize: '14px'
                                            }}
                                            title="First page"
                                        >
                                            &laquo;
                                        </button>
                                        <button
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '6px',
                                                border: '1px solid #E5E5EA',
                                                backgroundColor: currentPage === 1 ? '#F9F9F9' : '#fff',
                                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                opacity: currentPage === 1 ? 0.5 : 1,
                                                fontSize: '14px'
                                            }}
                                            title="Previous page"
                                        >
                                            &lsaquo;
                                        </button>

                                        {/* Page Numbers */}
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNum => {
                                            // Show first page, last page, current page, and pages around current
                                            const showPage = pageNum === 1 ||
                                                            pageNum === totalPages ||
                                                            (pageNum >= currentPage - 1 && pageNum <= currentPage + 1);
                                            
                                            // Show ellipsis
                                            if (!showPage && (pageNum === currentPage - 2 || pageNum === currentPage + 2)) {
                                                return <span key={pageNum} style={{padding: '8px 4px', color: '#8E8E93'}}>...</span>;
                                            }
                                            
                                            if (!showPage) return null;

                                            return (
                                                <button
                                                    key={pageNum}
                                                    onClick={() => handlePageChange(pageNum)}
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '6px',
                                                        border: '1px solid #E5E5EA',
                                                        backgroundColor: currentPage === pageNum ? '#007AFF' : '#fff',
                                                        color: currentPage === pageNum ? '#fff' : '#1C1C1E',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: currentPage === pageNum ? '600' : '400',
                                                        minWidth: '40px'
                                                    }}
                                                >
                                                    {pageNum}
                                                </button>
                                            );
                                        })}

                                        <button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '6px',
                                                border: '1px solid #E5E5EA',
                                                backgroundColor: currentPage === totalPages ? '#F9F9F9' : '#fff',
                                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                                opacity: currentPage === totalPages ? 0.5 : 1,
                                                fontSize: '14px'
                                            }}
                                            title="Next page"
                                        >
                                            &rsaquo;
                                        </button>
                                        <button
                                            onClick={() => handlePageChange(totalPages)}
                                            disabled={currentPage === totalPages}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '6px',
                                                border: '1px solid #E5E5EA',
                                                backgroundColor: currentPage === totalPages ? '#F9F9F9' : '#fff',
                                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                                opacity: currentPage === totalPages ? 0.5 : 1,
                                                fontSize: '14px'
                                            }}
                                            title="Last page"
                                        >
                                            &raquo;
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    </>
                )}

                {activeTab === 'roles' && (
                    <>
                        <div className="admin-header">
                            <h1>Client Features</h1>
                            <p className="admin-subtitle">Assign features to clients - users inherit features from their assigned clients</p>
                        </div>

                        {/* Search and Action Buttons */}
                        <div className="admin-actions" style={{gap: '12px'}}>
                            <div className="search-container" style={{flex: 1, maxWidth: '400px'}}>
                                <svg className="search-icon-admin" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zM16 16l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                <input
                                    type="text"
                                    placeholder="Search clients..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="admin-search-input"
                                />
                            </div>
                            <button className="btn-bulk-import" onClick={handleSyncDatabricksSpns} disabled={spnLoading} style={{whiteSpace: 'nowrap', flexShrink: 0}}>
                                {spnLoading ? 'Syncing...' : 'Sync from Databricks'}
                            </button>
                        </div>

                        {/* Client Features List */}
                        <div className="roles-container">
                            {loading ? (
                                <div className="loading-state">Loading clients...</div>
                            ) : clients.length === 0 ? (
                                <div style={{padding: '40px', textAlign: 'center', color: '#8E8E93'}}>
                                    <p style={{marginBottom: '8px'}}>No clients available</p>
                                    <p style={{fontSize: '14px'}}>Create clients first in the Users tab → Manage Clients</p>
                                </div>
                            ) : (
                                <div className="roles-list">
                                    <div className="role-header">
                                        <div className="role-header-col">Client Name</div>
                                        <div className="role-header-col">Assigned Features</div>
                                    </div>
                                    {clients
                                        .filter(client =>
                                            client.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                            client.description?.toLowerCase().includes(searchQuery.toLowerCase())
                                        )
                                        .map((client) => {
                                            // Get SPNs for this client from dedicated state
                                            const clientSpns = clientSpnsMap[client.name] || [];
                                            const isPreviewTarget = selectedClientForPreview?.name === client.name;

                                            return (
                                                <React.Fragment key={client.id}>
                                                <div className="role-card">
                                                    <div className="role-name">
                                                        <div style={{fontWeight: '600', fontSize: '15px'}}>{client.name}</div>
                                                        {client.description && (
                                                            <div style={{fontSize: '12px', color: '#8E8E93', marginTop: '4px'}}>
                                                                {client.description}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="role-features">
                                                        {clientSpns && clientSpns.length > 0 ? (
                                                           clientSpns.map(spn => (
                                                               <span key={spn} className="feature-badge">
                                                                   {spn.replace(/^spn_/i, '')}
                                                               </span>
                                                           ))
                                                        ) : (
                                                            <span className="no-features">No features assigned</span>
                                                        )}
                                                    </div>
                                                    <div className="role-actions" style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                                                        {/* View Dashboards button — loads this client's assigned PowerBI dashboards
                                                            with clientName as URL param, matching AdminTOSDashboard pattern */}
                                                        <button
                                                            className="btn-bulk-import"
                                                            onClick={() => {
                                                                if (isPreviewTarget) {
                                                                    setSelectedClientForPreview(null);
                                                                    setPreviewDashboards([]);
                                                                } else {
                                                                    loadPreviewDashboards(client);
                                                                }
                                                            }}
                                                            title={isPreviewTarget ? 'Hide dashboards' : `View PowerBI dashboards for "${client.name}"`}
                                                            style={{fontSize: '12px', padding: '5px 10px', whiteSpace: 'nowrap'}}
                                                        >
                                                            📊 {isPreviewTarget ? 'Hide' : 'Dashboards'}
                                                        </button>
                                                        <button
                                                            className="icon-btn edit-btn"
                                                            onClick={() => handleEditClientFeatures(client)}
                                                            title="Manage features"
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M11.333 2A2.827 2.827 0 0 1 14 4.667L12.667 6 10 3.333 11.333 2zM2 14h2.667L12 6.667 9.333 4 2 11.333V14z" fill="currentColor"/>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>

                                                {/* Inline PowerBI dashboard preview panel for this client */}
                                                {isPreviewTarget && (
                                                    <div style={{
                                                        margin: '0 0 8px 0',
                                                        padding: '16px 20px',
                                                        backgroundColor: '#F0F7FF',
                                                        border: '1px solid #007AFF',
                                                        borderRadius: '8px',
                                                        borderTop: 'none',
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0
                                                    }}>
                                                        <div style={{fontSize: '13px', fontWeight: '600', color: '#007AFF', marginBottom: '10px'}}>
                                                            📊 PowerBI Dashboards for <strong>{client.name}</strong>
                                                            <span style={{fontSize: '11px', fontWeight: '400', color: '#666', marginLeft: '8px'}}>
                                                                (clientName passed as URL param for RLS scoping)
                                                            </span>
                                                        </div>
                                                        {previewLoading ? (
                                                            <div style={{color: '#8E8E93', fontSize: '13px'}}>Loading dashboards…</div>
                                                        ) : previewDashboards.length === 0 ? (
                                                            <div style={{color: '#8E8E93', fontSize: '13px'}}>
                                                                No PowerBI dashboards assigned to this client.
                                                                <button
                                                                    className="btn-bulk-import"
                                                                    onClick={() => handleEditClientFeatures(client)}
                                                                    style={{marginLeft: '12px', fontSize: '12px', padding: '3px 10px'}}
                                                                >
                                                                    Assign Dashboards
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                                                                {previewDashboards.map(dashboardId => {
                                                                    const dashInfo = availableDashboards.find(d => d.id === dashboardId);
                                                                    const dashName = dashInfo?.name || dashboardId;
                                                                    return (
                                                                        <div key={dashboardId} style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '8px',
                                                                            padding: '6px 12px',
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #007AFF',
                                                                            borderRadius: '6px'
                                                                        }}>
                                                                            <span style={{fontSize: '13px', fontWeight: '500', color: '#1C1C1E'}}>
                                                                                {dashName}
                                                                            </span>
                                                                            {/* Opens PowerBIDashboard with clientName as URL param
                                                                                — server uses it for RLS (same as AdminTOSDashboard pattern) */}
                                                                            <button
                                                                                onClick={() => handlePreviewClientDashboard(client, dashboardId, dashName)}
                                                                                style={{
                                                                                    padding: '3px 10px',
                                                                                    borderRadius: '5px',
                                                                                    border: '1px solid #007AFF',
                                                                                    backgroundColor: '#007AFF',
                                                                                    color: '#fff',
                                                                                    fontSize: '11px',
                                                                                    fontWeight: '600',
                                                                                    cursor: 'pointer',
                                                                                    whiteSpace: 'nowrap'
                                                                                }}
                                                                                title={`Open "${dashName}" scoped to client "${client.name}"`}
                                                                            >
                                                                                👁 Open
                                                                            </button>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                </React.Fragment>
                                            );
                                        })}
                                </div>
                            )}
                        </div>
                    </>
                )}

            {/* ── SPN-Genies Tab ─────────────────────────────────────── */}
            {activeTab === 'spn-genies' && (
                <>
                    <div className="admin-header">
                        <h1>SPN-Genies</h1>
                        <p className="admin-subtitle">
                            Manage Genie Space mappings for each Service Principal — all data is read/written directly to Databricks Secrets
                        </p>
                    </div>

                    {/* Toolbar: Refresh + Overview + Search + Filter + Checkbox */}
                    <div className="admin-actions" style={{ gap: '12px', flexWrap: 'wrap' }}>
                        <button
                            className="btn-bulk-import"
                            onClick={fetchSpnGenieMap}
                            disabled={spnGenieLoading}
                            style={{ whiteSpace: 'nowrap', flexShrink: 0, marginLeft: 0 }}
                        >
                            {spnGenieLoading ? 'Loading...' : '↻ Refresh'}
                        </button>

                        <button
                            className="btn-bulk-import"
                            onClick={() => {
                                setShowDatabricksOverviewModal(true);
                                setOverviewSpnPage(1);
                                setOverviewGeniePage(1);
                                if (databricksSpns.length === 0) fetchDatabricksOverview();
                            }}
                            style={{ whiteSpace: 'nowrap', flexShrink: 0, marginLeft: 0 }}
                        >
                            📊 Overview
                        </button>

                        {/* Search */}
                        <div className="search-container" style={{ flex: '1', minWidth: '180px', maxWidth: '320px' }}>
                            <svg className="search-icon-admin" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zM16 16l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <input
                                type="text"
                                placeholder="Search SPNs..."
                                value={spnGenieSearch}
                                onChange={e => setSpnGenieSearch(e.target.value)}
                                className="admin-search-input"
                            />
                        </div>

                        {/* Filter dropdown */}
                        <div className="filter-dropdown" style={{ position: 'relative', flexShrink: 0 }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#666', pointerEvents: 'none', zIndex: 1 }}>
                                <path d="M2 4h12M4 8h8M6 12h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <select
                                value={spnGenieFilter}
                                onChange={e => setSpnGenieFilter(e.target.value)}
                                className="admin-filter-select"
                                style={{ paddingLeft: '36px' }}
                            >
                                <option value="all">All SPNs</option>
                                <option value="oauth">Has OAuth</option>
                                <option value="no-oauth">No OAuth</option>
                                <option value="scim">In SCIM</option>
                                <option value="no-scim">Secrets Only</option>
                                <option value="with-genies">Has Genie Mappings</option>
                                <option value="no-genies">No Genie Mappings</option>
                            </select>
                        </div>

                        {/* Mapped-to-client checkbox */}
                        <label style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '13px',
                            color: '#CCC',
                            cursor: 'pointer',
                            flexShrink: 0,
                            userSelect: 'none',
                            padding: '6px 12px',
                            border: `1px solid ${spnGenieMappedOnly ? 'rgba(59,130,246,0.6)' : '#333'}`,
                            borderRadius: '6px',
                            backgroundColor: spnGenieMappedOnly ? 'rgba(59,130,246,0.1)' : 'transparent',
                            transition: 'all 0.15s'
                        }}>
                            <input
                                type="checkbox"
                                checked={spnGenieMappedOnly}
                                onChange={e => setSpnGenieMappedOnly(e.target.checked)}
                                style={{ accentColor: '#3B82F6', cursor: 'pointer' }}
                            />
                            Mapped to Client only
                        </label>

                        {/* Workspace Selector */}
                        <div className="filter-dropdown" style={{ position: 'relative', flexShrink: 0, marginLeft: 'auto' }}>
                            <button
                                className="admin-filter-select"
                                onClick={() => setShowWorkspaceDropdown(!showWorkspaceDropdown)}
                                style={{ paddingRight: '12px', textAlign: 'left', minWidth: '160px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#1A1A1A', border: '1px solid #333', color: '#FFF' }}
                            >
                                <span>Workspace(s) ({selectedDatabricksHosts.length})</span>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ marginLeft: '8px' }}>
                                    <path d="M3 4.5l3 3 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                            {showWorkspaceDropdown && (
                                <>
                                    <div
                                        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99 }}
                                        onClick={() => setShowWorkspaceDropdown(false)}
                                    />
                                    <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        right: 0,
                                        marginTop: '4px',
                                        backgroundColor: '#2A2A2A',
                                        border: '1px solid #444',
                                        borderRadius: '6px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
                                        zIndex: 100,
                                        minWidth: '220px',
                                        padding: '8px 0'
                                    }}>
                                        {availableDatabricksHosts.map(host => {
                                            const isChecked = selectedDatabricksHosts.includes(host.id);
                                            return (
                                                <label
                                                    key={host.id}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '8px 16px',
                                                        cursor: 'pointer',
                                                        color: '#FFF',
                                                        fontSize: '13px',
                                                        transition: 'background-color 0.2s',
                                                        margin: 0
                                                    }}
                                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#333'}
                                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={isChecked}
                                                        onChange={() => {
                                                            setSelectedDatabricksHosts(prev => {
                                                                if (prev.includes(host.id)) {
                                                                    if (prev.length === 1) return prev;
                                                                    return prev.filter(h => h !== host.id);
                                                                }
                                                                return [...prev, host.id];
                                                            });
                                                        }}
                                                        style={{ marginRight: '10px', accentColor: '#3B82F6', width: '16px', height: '16px', cursor: 'pointer' }}
                                                    />
                                                    {host.name}
                                                </label>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    
                    {/* Display selected workspaces */}
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
                        {selectedDatabricksHosts.map(hostId => {
                            const hostDef = availableDatabricksHosts.find(h => h.id === hostId);
                            return (
                                <span key={hostId} style={{
                                    fontSize: '12px',
                                    padding: '4px 8px',
                                    backgroundColor: 'rgba(59,130,246,0.1)',
                                    color: '#3B82F6',
                                    borderRadius: '12px',
                                    border: '1px solid rgba(59,130,246,0.2)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}>
                                    {hostDef ? hostDef.name : hostId}
                                    {selectedDatabricksHosts.length > 1 && (
                                        <button
                                            onClick={() => setSelectedDatabricksHosts(prev => prev.filter(h => h !== hostId))}
                                            style={{ background: 'none', border: 'none', color: '#3B82F6', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}
                                        >×</button>
                                    )}
                                </span>
                            );
                        })}
                    </div>

                    {spnGenieError && (
                        <div style={{
                            padding: '12px 16px',
                            backgroundColor: 'rgba(239,68,68,0.1)',
                            border: '1px solid rgba(239,68,68,0.3)',
                            borderRadius: '8px',
                            color: '#EF4444',
                            fontSize: '14px',
                            marginBottom: '24px'
                        }}>
                            ⚠️ {spnGenieError}
                        </div>
                    )}

                    {spnGenieLoading ? (
                        <div className="loading-state">Fetching SPN-Genie map from Databricks...</div>
                    ) : (() => {
                        // Build the set of SPN names that are mapped to at least one client
                        const clientMappedSpnNames = new Set(
                            Object.values(clientSpnsMap).flat().map(s => s.toLowerCase())
                        );

                        // Apply all active filters
                        const filteredSpns = spnGenieMap.filter(spn => {
                            if (spnGenieSearch && !spn.name.toLowerCase().includes(spnGenieSearch.toLowerCase())) return false;
                            if (spnGenieFilter === 'oauth' && !spn.hasOAuthCredentials) return false;
                            if (spnGenieFilter === 'no-oauth' && spn.hasOAuthCredentials) return false;
                            if (spnGenieFilter === 'scim' && !spn.inScim) return false;
                            if (spnGenieFilter === 'no-scim' && spn.inScim) return false;
                            if (spnGenieFilter === 'with-genies' && !(spn.genies && spn.genies.length > 0)) return false;
                            if (spnGenieFilter === 'no-genies' && spn.genies && spn.genies.length > 0) return false;
                            if (spnGenieMappedOnly && !clientMappedSpnNames.has(spn.name.toLowerCase())) return false;
                            return true;
                        });

                        return (
                            <div className="admin-table-container">
                                {spnGenieMap.length === 0 ? (
                                    <div className="loading-state" style={{ padding: '40px' }}>
                                        No Service Principals found. Click Refresh.
                                    </div>
                                ) : filteredSpns.length === 0 ? (
                                    <div className="loading-state" style={{ padding: '40px' }}>
                                        No SPNs match the current filters.{' '}
                                        <button
                                            onClick={() => { setSpnGenieSearch(''); setSpnGenieFilter('all'); setSpnGenieMappedOnly(false); }}
                                            style={{ color: '#3B82F6', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', fontSize: '14px' }}
                                        >
                                            Clear filters
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        {/* Result count */}
                                        <div style={{ padding: '10px 16px', fontSize: '13px', color: '#666', borderBottom: '1px solid #2A2A2A' }}>
                                            Showing <strong style={{ color: '#CCC' }}>{filteredSpns.length}</strong> of <strong style={{ color: '#CCC' }}>{spnGenieMap.length}</strong> SPNs
                                            {(spnGenieSearch || spnGenieFilter !== 'all' || spnGenieMappedOnly) && (
                                                <button
                                                    onClick={() => { setSpnGenieSearch(''); setSpnGenieFilter('all'); setSpnGenieMappedOnly(false); }}
                                                    style={{ marginLeft: '12px', fontSize: '12px', color: '#3B82F6', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}
                                                >
                                                    Clear filters
                                                </button>
                                            )}
                                        </div>
                                        <table className="admin-table" style={{ minWidth: '560px' }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '40px' }}>#</th>
                                                    <th>SPN Name</th>
                                                    <th style={{ width: '40px' }}>Workspace</th>
                                                    <th>Mapped Genie Spaces</th>
                                                    <th style={{ width: '210px', textAlign: 'center' }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredSpns.map((spn, idx) => {
                                                    return (
                                                        <tr key={spn.name}>
                                                            <td style={{ color: '#666', fontSize: '13px' }}>{idx + 1}</td>
                                                            <td style={{ fontWeight: '500' }}>
                                                                {spn.name}
                                                                {spn.scimId && (
                                                                    <div style={{ fontSize: '11px', color: '#666', fontFamily: 'monospace', marginTop: '2px' }}>
                                                                        {spn.scimId}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {spn.workspaces && spn.workspaces.length > 0 ? spn.workspaces.map(ws => (
                                                                    <div key={ws} style={{
                                                                        fontSize: '11px',
                                                                        display: 'inline-block',
                                                                        padding: '2px 6px',
                                                                        marginRight: '4px',
                                                                        marginBottom: '2px',
                                                                        backgroundColor: 'rgba(59,130,246,0.1)',
                                                                        color: '#3B82F6',
                                                                        borderRadius: '4px',
                                                                        border: '1px solid rgba(59,130,246,0.2)'
                                                                    }}>
                                                                        {ws === 'LOCAL_DATABRICKS_HOST' ? 'Default' : 'Tripshot'}
                                                                    </div>
                                                                )) : (
                                                                    <span style={{color: '#8E8E93', fontSize: '11px'}}>Unknown</span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {spn.genies && spn.genies.length > 0 ? (
                                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                                                        {spn.genies.map(g => (
                                                                            <span key={g.id} style={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                gap: '6px',
                                                                                padding: '3px 8px 3px 10px',
                                                                                backgroundColor: 'rgba(139,92,246,0.1)',
                                                                                border: '1px solid rgba(139,92,246,0.3)',
                                                                                borderRadius: '12px',
                                                                                fontSize: '12px',
                                                                                color: '#A78BFA'
                                                                            }}>
                                                                                {g.title}
                                                                                <button
                                                                                    onClick={() => handleRemoveGenie(spn.name, g.id)}
                                                                                    title={`Remove ${g.title}`}
                                                                                    style={{
                                                                                        background: 'none',
                                                                                        border: 'none',
                                                                                        cursor: 'pointer',
                                                                                        color: '#EF4444',
                                                                                        fontSize: '14px',
                                                                                        lineHeight: '1',
                                                                                        padding: '0',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center'
                                                                                    }}
                                                                                >×</button>
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                ) : (
                                                                    <span style={{ color: '#8E8E93', fontSize: '13px' }}>No Genie Spaces mapped</span>
                                                                )}
                                                            </td>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                                                    <button
                                                                        className="btn-primary"
                                                                        onClick={() => openAddGenieModal(spn)}
                                                                        style={{ padding: '5px 12px', fontSize: '12px', borderRadius: '6px' }}
                                                                    >
                                                                        + Add Genie
                                                                    </button>
                                                                    <button
                                                                        className="btn-secondary"
                                                                        onClick={() => handleTestGenie(spn)}
                                                                        title={`Test all Genie Spaces mapped to ${spn.name}`}
                                                                        style={{ padding: '5px 12px', fontSize: '12px', borderRadius: '6px', whiteSpace: 'nowrap' }}
                                                                    >
                                                                        ⚡ Test
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </>
                                )}
                            </div>
                        );
                    })()}

                    {/* Summary cards */}
                    {!spnGenieLoading && spnGenieMap.length > 0 && (
                        <div style={{ display: 'flex', gap: '16px', marginTop: '24px', flexWrap: 'wrap' }}>
                            {(() => {
                                return [
                                    { label: 'Total SPNs', value: spnGenieMap.length, color: '#3B82F6' },
                                    { label: 'With Genies', value: spnGenieMap.filter(s => s.genies && s.genies.length > 0).length, color: '#8B5CF6' },
                                    { label: 'No Genies', value: spnGenieMap.filter(s => !s.genies || s.genies.length === 0).length, color: '#F59E0B' },
                                    { label: 'Available Spaces', value: spnGenieAllSpaces.length, color: '#6366F1' }
                                ].map(card => (
                                    <div key={card.label} style={{
                                        padding: '14px 20px',
                                        backgroundColor: '#1A1A1A',
                                        border: `1px solid ${card.color}33`,
                                        borderRadius: '10px',
                                        minWidth: '130px',
                                        textAlign: 'center'
                                    }}>
                                        <div style={{ fontSize: '24px', fontWeight: '700', color: card.color }}>{card.value}</div>
                                        <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>{card.label}</div>
                                    </div>
                                ));
                            })()}
                        </div>
                    )}
                </>
            )}

            </div>

            {/* Add Genie Modal */}
            {showAddGenieModal && addGenieTarget && (
                <div className="modal-overlay" onClick={closeAddGenieModal}>
                    <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '560px' }}>
                        <div className="modal-header">
                            <h2>Add Genie Space to {addGenieTarget.name}</h2>
                            <button className="modal-close" onClick={closeAddGenieModal}>&times;</button>
                        </div>
                        <div className="modal-body">
                            {addGenieError && (
                                <div style={{
                                    padding: '10px 14px',
                                    backgroundColor: 'rgba(239,68,68,0.1)',
                                    border: '1px solid rgba(239,68,68,0.3)',
                                    borderRadius: '6px',
                                    color: '#EF4444',
                                    fontSize: '13px',
                                    marginBottom: '14px'
                                }}>
                                    ⚠️ {addGenieError}
                                </div>
                            )}

                            {addGenieTarget.genies && addGenieTarget.genies.length > 0 && (
                                <div style={{ marginBottom: '18px' }}>
                                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#999', marginBottom: '8px' }}>
                                        Currently mapped ({addGenieTarget.genies.length})
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                        {addGenieTarget.genies.map(g => (
                                            <span key={g.id} style={{
                                                padding: '3px 10px',
                                                backgroundColor: 'rgba(139,92,246,0.15)',
                                                border: '1px solid rgba(139,92,246,0.4)',
                                                borderRadius: '10px',
                                                fontSize: '12px',
                                                color: '#A78BFA'
                                            }}>
                                                ✓ {g.title}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div style={{ position: 'relative', marginBottom: '12px' }}>
                                <svg style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#666' }} width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10zM14 14l-3-3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                                </svg>
                                <input
                                    type="text"
                                    placeholder="Search Genie Spaces..."
                                    value={addGenieSearch}
                                    onChange={e => setAddGenieSearch(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px 8px 34px',
                                        borderRadius: '6px',
                                        border: '1px solid #333',
                                        backgroundColor: '#1A1A1A',
                                        color: '#FFF',
                                        fontSize: '13px',
                                        boxSizing: 'border-box'
                                    }}
                                    autoFocus
                                />
                            </div>

                            <div style={{ maxHeight: '320px', overflowY: 'auto', border: '1px solid #2A2A2A', borderRadius: '8px' }}>
                                {spnGenieAllSpaces
                                    .filter(space =>
                                        !addGenieSearch ||
                                        space.title.toLowerCase().includes(addGenieSearch.toLowerCase()) ||
                                        space.id.toLowerCase().includes(addGenieSearch.toLowerCase())
                                    )
                                    .map(space => {
                                        const alreadyMapped = (addGenieTarget.genieIds || []).includes(space.id);
                                        return (
                                            <div
                                                key={space.id}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '12px 16px',
                                                    borderBottom: '1px solid #2A2A2A',
                                                    backgroundColor: alreadyMapped ? 'rgba(139,92,246,0.06)' : 'transparent'
                                                }}
                                            >
                                                <div>
                                                    <div style={{ fontSize: '14px', fontWeight: '500', color: alreadyMapped ? '#A78BFA' : '#FFF' }}>
                                                        {alreadyMapped && '✓ '}{space.title}
                                                    </div>
                                                    <div style={{ fontSize: '11px', color: '#666', fontFamily: 'monospace', marginTop: '2px' }}>{space.id}</div>
                                                </div>
                                                {alreadyMapped ? (
                                                    <span style={{ fontSize: '12px', color: '#A78BFA', flexShrink: 0 }}>Mapped</span>
                                                ) : (
                                                    <button
                                                        onClick={() => handleAddGenie(space.id)}
                                                        disabled={addGenieSaving}
                                                        className="btn-primary"
                                                        style={{ padding: '4px 12px', fontSize: '12px', flexShrink: 0 }}
                                                    >
                                                        {addGenieSaving ? '...' : '+ Add'}
                                                    </button>
                                                )}
                                            </div>
                                        );
                                    })}
                                {spnGenieAllSpaces.filter(space =>
                                    !addGenieSearch ||
                                    space.title.toLowerCase().includes(addGenieSearch.toLowerCase()) ||
                                    space.id.toLowerCase().includes(addGenieSearch.toLowerCase())
                                ).length === 0 && (
                                    <div style={{ padding: '30px', textAlign: 'center', color: '#666', fontSize: '13px' }}>
                                        No Genie Spaces match your search
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-secondary" onClick={closeAddGenieModal}>
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Test Genie Modal ────────────────────────────────────────── */}
            {showTestGenieModal && testGenieTarget && (
                <div className="modal-overlay" onClick={closeTestGenieModal}>
                    <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '600px' }}>
                        <div className="modal-header">
                            <h2>⚡ Test Genie Access — {testGenieTarget.name}</h2>
                            <button className="modal-close" onClick={closeTestGenieModal}>&times;</button>
                        </div>
                        <div className="modal-body">

                            {/* Loading spinner */}
                            {testGenieLoading && (
                                <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                    <div style={{
                                        width: '40px', height: '40px', border: '3px solid #333',
                                        borderTop: '3px solid #3B82F6', borderRadius: '50%',
                                        animation: 'spin 0.8s linear infinite', margin: '0 auto 16px'
                                    }} />
                                    <div style={{ color: '#999', fontSize: '14px' }}>
                                        Authenticating as SPN and testing Genie Spaces…
                                    </div>
                                </div>
                            )}

                            {/* Network / unexpected error */}
                            {!testGenieLoading && testGenieError && (
                                <div style={{
                                    padding: '14px 16px',
                                    backgroundColor: 'rgba(239,68,68,0.1)',
                                    border: '1px solid rgba(239,68,68,0.3)',
                                    borderRadius: '8px',
                                    color: '#EF4444',
                                    fontSize: '14px'
                                }}>
                                    ⚠️ {testGenieError}
                                </div>
                            )}

                            {/* Results */}
                            {!testGenieLoading && testGenieResults && (
                                <>
                                    {/* Credential / OAuth status banner */}
                                    {!testGenieResults.hasCredentials ? (
                                        <div style={{
                                            padding: '12px 16px',
                                            backgroundColor: 'rgba(245,158,11,0.1)',
                                            border: '1px solid rgba(245,158,11,0.3)',
                                            borderRadius: '8px',
                                            color: '#F59E0B',
                                            fontSize: '13px',
                                            marginBottom: '16px'
                                        }}>
                                            ⚠️ <strong>No OAuth credentials</strong> — {testGenieResults.message}
                                        </div>
                                    ) : testGenieResults.oauthError ? (
                                        <div style={{
                                            padding: '12px 16px',
                                            backgroundColor: 'rgba(239,68,68,0.1)',
                                            border: '1px solid rgba(239,68,68,0.3)',
                                            borderRadius: '8px',
                                            color: '#EF4444',
                                            fontSize: '13px',
                                            marginBottom: '16px'
                                        }}>
                                            ❌ <strong>OAuth authentication failed</strong><br />
                                            <span style={{ fontFamily: 'monospace', fontSize: '12px', wordBreak: 'break-all' }}>
                                                {testGenieResults.oauthError}
                                            </span>
                                        </div>
                                    ) : (
                                        <div style={{
                                            padding: '10px 14px',
                                            backgroundColor: 'rgba(16,185,129,0.1)',
                                            border: '1px solid rgba(16,185,129,0.3)',
                                            borderRadius: '8px',
                                            color: '#10B981',
                                            fontSize: '13px',
                                            marginBottom: '16px'
                                        }}>
                                            ✅ OAuth token obtained successfully
                                        </div>
                                    )}

                                    {/* Summary message */}
                                    <div style={{ fontSize: '13px', color: '#999', marginBottom: '12px' }}>
                                        {testGenieResults.message}
                                    </div>

                                    {/* Per-genie results list */}
                                    {testGenieResults.results && testGenieResults.results.length > 0 && (
                                        <div style={{ border: '1px solid #2A2A2A', borderRadius: '8px', overflow: 'hidden' }}>
                                            {testGenieResults.results.map((r, idx) => (
                                                <div key={r.genieId} style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    gap: '12px',
                                                    padding: '14px 16px',
                                                    borderBottom: idx < testGenieResults.results.length - 1 ? '1px solid #2A2A2A' : 'none',
                                                    backgroundColor: r.status === 'ok'
                                                        ? 'rgba(16,185,129,0.04)'
                                                        : 'rgba(239,68,68,0.04)'
                                                }}>
                                                    {/* Status icon */}
                                                    <span style={{ fontSize: '18px', flexShrink: 0, marginTop: '1px' }}>
                                                        {r.status === 'ok' ? '✅' : '❌'}
                                                    </span>
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                    {/* Genie title */}
                                                    <div style={{ fontWeight: '600', fontSize: '14px', color: r.status === 'ok' ? '#10B981' : '#EF4444' }}>
                                                        {r.title && r.title !== r.genieId ? r.title : <span style={{ color: '#999', fontStyle: 'italic' }}>Space ID: {r.genieId}</span>}
                                                    </div>
                                                    {/* Genie ID (only show separately when we have a real title) */}
                                                    {r.title && r.title !== r.genieId && (
                                                        <div style={{ fontSize: '11px', color: '#666', fontFamily: 'monospace', marginTop: '2px', wordBreak: 'break-all' }}>
                                                            {r.genieId}
                                                        </div>
                                                    )}
                                                    {/* Error message if any */}
                                                    {r.status === 'error' && (() => {
                                                        // Map errorCode to a friendly human-readable explanation
                                                        const friendlyReason = (() => {
                                                            switch (r.errorCode) {
                                                                case 'RESOURCE_DOES_NOT_EXIST':
                                                                    return 'Genie Space not found — it may have been deleted or the Space ID is stale. Remove this mapping and re-add the correct space.';
                                                                case 'PERMISSION_DENIED':
                                                                    return 'SPN does not have permission to access this Genie Space. Grant "Can View" access to the SPN in the Databricks workspace.';
                                                                case 'UNAUTHENTICATED':
                                                                    return 'Authentication failed — the SPN OAuth token was rejected by this Genie Space.';
                                                                case 'NOT_FOUND':
                                                                    return 'Genie Space not found (404). The Space ID may be incorrect or the space was deleted.';
                                                                default:
                                                                    return null;
                                                            }
                                                        })();
                                                        return (
                                                            <div style={{ marginTop: '8px' }}>
                                                                {/* Friendly reason (if known) */}
                                                                {friendlyReason && (
                                                                    <div style={{
                                                                        marginBottom: '6px',
                                                                        padding: '6px 10px',
                                                                        backgroundColor: 'rgba(245,158,11,0.08)',
                                                                        border: '1px solid rgba(245,158,11,0.25)',
                                                                        borderRadius: '4px',
                                                                        fontSize: '12px',
                                                                        color: '#F59E0B',
                                                                        lineHeight: '1.5'
                                                                    }}>
                                                                        💡 {friendlyReason}
                                                                    </div>
                                                                )}
                                                                {/* Raw Databricks message */}
                                                                {r.error && (
                                                                    <div style={{
                                                                        padding: '5px 9px',
                                                                        backgroundColor: 'rgba(239,68,68,0.07)',
                                                                        border: '1px solid rgba(239,68,68,0.18)',
                                                                        borderRadius: '4px',
                                                                        fontSize: '11px',
                                                                        color: '#999',
                                                                        wordBreak: 'break-all',
                                                                        lineHeight: '1.5'
                                                                    }}>
                                                                        {r.httpStatus && <span style={{ color: '#EF4444', fontWeight: '600', marginRight: '6px' }}>HTTP {r.httpStatus}</span>}
                                                                        {r.errorCode && <span style={{ color: '#F87171', marginRight: '6px' }}>[{r.errorCode}]</span>}
                                                                        {r.error}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                                    {/* Response time */}
                                                    {r.responseTimeMs !== undefined && (
                                                        <span style={{ fontSize: '11px', color: '#666', flexShrink: 0, marginTop: '3px' }}>
                                                            {r.responseTimeMs}ms
                                                        </span>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* No mapped genies note */}
                                    {testGenieResults.results && testGenieResults.results.length === 0 && testGenieResults.oauthOk && (
                                        <div style={{ padding: '30px', textAlign: 'center', color: '#666', fontSize: '13px' }}>
                                            No Genie Spaces are mapped to this SPN yet.<br />
                                            Use <strong>+ Add Genie</strong> to map some.
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-secondary" onClick={closeTestGenieModal}>
                                Close
                            </button>
                            {/* Re-run test button */}
                            {!testGenieLoading && (
                                <button
                                    type="button"
                                    className="btn-primary"
                                    onClick={() => handleTestGenie(testGenieTarget)}
                                    style={{ marginLeft: '8px' }}
                                >
                                    ↻ Re-run Test
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* ── Databricks Overview Modal ──────────────────────────────── */}
            {showDatabricksOverviewModal && (
                <div className="modal-overlay" onClick={() => setShowDatabricksOverviewModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto' }}>
                        <div className="modal-header">
                            <h2>📊 Databricks Overview</h2>
                            <button className="modal-close" onClick={() => setShowDatabricksOverviewModal(false)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            {databricksHost && (
                                <div style={{ fontSize: '13px', color: '#666', marginBottom: '16px' }}>
                                    Workspace: <span style={{ color: '#3B82F6' }}>{databricksHost}</span>
                                </div>
                            )}

                            {databricksError && (
                                <div style={{
                                    padding: '12px 16px',
                                    backgroundColor: 'rgba(239,68,68,0.1)',
                                    border: '1px solid rgba(239,68,68,0.3)',
                                    borderRadius: '8px',
                                    color: '#EF4444',
                                    fontSize: '14px',
                                    marginBottom: '16px'
                                }}>
                                    ⚠️ {databricksError}
                                </div>
                            )}

                            {databricksLoading ? (
                                <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                    <div style={{
                                        width: '36px', height: '36px', border: '3px solid #333',
                                        borderTop: '3px solid #3B82F6', borderRadius: '50%',
                                        animation: 'spin 0.8s linear infinite', margin: '0 auto 12px'
                                    }} />
                                    <div style={{ color: '#999', fontSize: '14px' }}>Fetching data from Databricks...</div>
                                </div>
                            ) : (
                                <>
                                    {/* Service Principals Table */}
                                    <div style={{ marginBottom: '28px' }}>
                                        <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#FFF', marginBottom: '10px' }}>
                                            Service Principals
                                            <span style={{ marginLeft: '8px', fontSize: '12px', fontWeight: '500', color: '#3B82F6', backgroundColor: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.2)', borderRadius: '10px', padding: '2px 8px' }}>
                                                {databricksSpns.length}
                                            </span>
                                        </h3>
                                        {databricksSpns.length === 0 ? (
                                            <div style={{ padding: '24px', textAlign: 'center', color: '#666', fontSize: '13px', border: '1px solid #2A2A2A', borderRadius: '8px' }}>
                                                No Service Principals found
                                            </div>
                                        ) : (
                                            <>
                                                <div style={{ border: '1px solid #2A2A2A', borderRadius: '8px', overflow: 'hidden' }}>
                                                    <table className="admin-table" style={{ minWidth: '400px', margin: 0 }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '44px' }}>#</th>
                                                                <th>SPN Name</th>
                                                                <th>SCIM ID</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {databricksSpns
                                                                .slice((overviewSpnPage - 1) * OVERVIEW_PAGE_SIZE, overviewSpnPage * OVERVIEW_PAGE_SIZE)
                                                                .map((spn, idx) => (
                                                                    <tr key={spn.id}>
                                                                        <td style={{ color: '#666', fontSize: '13px' }}>{(overviewSpnPage - 1) * OVERVIEW_PAGE_SIZE + idx + 1}</td>
                                                                        <td style={{ fontWeight: '500' }}>{spn.displayName}</td>
                                                                        <td style={{ fontFamily: 'monospace', fontSize: '12px', color: '#3B82F6' }}>{spn.id}</td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* SPN Pagination */}
                                                {Math.ceil(databricksSpns.length / OVERVIEW_PAGE_SIZE) > 1 && (
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px', fontSize: '12px', color: '#666' }}>
                                                        <span>Showing {(overviewSpnPage - 1) * OVERVIEW_PAGE_SIZE + 1}–{Math.min(overviewSpnPage * OVERVIEW_PAGE_SIZE, databricksSpns.length)} of {databricksSpns.length}</span>
                                                        <div style={{ display: 'flex', gap: '6px' }}>
                                                            <button onClick={() => setOverviewSpnPage(p => Math.max(1, p - 1))} disabled={overviewSpnPage === 1} style={{ padding: '3px 10px', borderRadius: '4px', border: '1px solid #333', background: '#1A1A1A', color: '#CCC', cursor: overviewSpnPage === 1 ? 'not-allowed' : 'pointer', opacity: overviewSpnPage === 1 ? 0.5 : 1 }}>‹</button>
                                                            <button onClick={() => setOverviewSpnPage(p => Math.min(Math.ceil(databricksSpns.length / OVERVIEW_PAGE_SIZE), p + 1))} disabled={overviewSpnPage === Math.ceil(databricksSpns.length / OVERVIEW_PAGE_SIZE)} style={{ padding: '3px 10px', borderRadius: '4px', border: '1px solid #333', background: '#1A1A1A', color: '#CCC', cursor: overviewSpnPage === Math.ceil(databricksSpns.length / OVERVIEW_PAGE_SIZE) ? 'not-allowed' : 'pointer', opacity: overviewSpnPage === Math.ceil(databricksSpns.length / OVERVIEW_PAGE_SIZE) ? 0.5 : 1 }}>›</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    {/* Genie Spaces Table */}
                                    <div>
                                        <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#FFF', marginBottom: '10px' }}>
                                            Genie Spaces
                                            <span style={{ marginLeft: '8px', fontSize: '12px', fontWeight: '500', color: '#8B5CF6', backgroundColor: 'rgba(139,92,246,0.1)', border: '1px solid rgba(139,92,246,0.2)', borderRadius: '10px', padding: '2px 8px' }}>
                                                {databricksGenieSpaces.length}
                                            </span>
                                        </h3>
                                        {databricksGenieSpaces.length === 0 ? (
                                            <div style={{ padding: '24px', textAlign: 'center', color: '#666', fontSize: '13px', border: '1px solid #2A2A2A', borderRadius: '8px' }}>
                                                No Genie Spaces found
                                            </div>
                                        ) : (
                                            <>
                                                <div style={{ border: '1px solid #2A2A2A', borderRadius: '8px', overflow: 'hidden' }}>
                                                    <table className="admin-table" style={{ minWidth: '400px', margin: 0 }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '44px' }}>#</th>
                                                                <th>Genie Space Name</th>
                                                                <th>Space ID</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {databricksGenieSpaces
                                                                .slice((overviewGeniePage - 1) * OVERVIEW_PAGE_SIZE, overviewGeniePage * OVERVIEW_PAGE_SIZE)
                                                                .map((space, idx) => (
                                                                    <tr key={space.id}>
                                                                        <td style={{ color: '#666', fontSize: '13px' }}>{(overviewGeniePage - 1) * OVERVIEW_PAGE_SIZE + idx + 1}</td>
                                                                        <td style={{ fontWeight: '500' }}>{space.title}</td>
                                                                        <td style={{ fontFamily: 'monospace', fontSize: '12px', color: '#8B5CF6' }}>{space.id}</td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* Genie Pagination */}
                                                {Math.ceil(databricksGenieSpaces.length / OVERVIEW_PAGE_SIZE) > 1 && (
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px', fontSize: '12px', color: '#666' }}>
                                                        <span>Showing {(overviewGeniePage - 1) * OVERVIEW_PAGE_SIZE + 1}–{Math.min(overviewGeniePage * OVERVIEW_PAGE_SIZE, databricksGenieSpaces.length)} of {databricksGenieSpaces.length}</span>
                                                        <div style={{ display: 'flex', gap: '6px' }}>
                                                            <button onClick={() => setOverviewGeniePage(p => Math.max(1, p - 1))} disabled={overviewGeniePage === 1} style={{ padding: '3px 10px', borderRadius: '4px', border: '1px solid #333', background: '#1A1A1A', color: '#CCC', cursor: overviewGeniePage === 1 ? 'not-allowed' : 'pointer', opacity: overviewGeniePage === 1 ? 0.5 : 1 }}>‹</button>
                                                            <button onClick={() => setOverviewGeniePage(p => Math.min(Math.ceil(databricksGenieSpaces.length / OVERVIEW_PAGE_SIZE), p + 1))} disabled={overviewGeniePage === Math.ceil(databricksGenieSpaces.length / OVERVIEW_PAGE_SIZE)} style={{ padding: '3px 10px', borderRadius: '4px', border: '1px solid #333', background: '#1A1A1A', color: '#CCC', cursor: overviewGeniePage === Math.ceil(databricksGenieSpaces.length / OVERVIEW_PAGE_SIZE) ? 'not-allowed' : 'pointer', opacity: overviewGeniePage === Math.ceil(databricksGenieSpaces.length / OVERVIEW_PAGE_SIZE) ? 0.5 : 1 }}>›</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-secondary" onClick={() => setShowDatabricksOverviewModal(false)}>
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn-primary"
                                onClick={fetchDatabricksOverview}
                                disabled={databricksLoading}
                                style={{ marginLeft: '8px' }}
                            >
                                {databricksLoading ? 'Refreshing...' : '↻ Refresh'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add User Modal */}
            {showAddUserModal && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Add New User</h2>
                            <button className="modal-close" onClick={handleCloseModal}>&times;</button>
                        </div>
                        <form onSubmit={handleCreateUser}>
                            <div className="modal-body">
                                {userFormError && <div className="error-message">{userFormError}</div>}
                                {userFormSuccess && <div className="success-message">{userFormSuccess}</div>}
                                
                                <div className="form-group">
                                    <label>Display Name *</label>
                                    <input
                                        type="text"
                                        name="displayName"
                                        value={newUserData.displayName}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="John Doe"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Email Address *</label>
                                    <input
                                        type="email"
                                        name="userPrincipalName"
                                        value={newUserData.userPrincipalName}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="john.doe@gmail.com"
                                    />
                                    <small style={{color: '#8E8E93', fontSize: '12px', marginTop: '4px', display: 'block'}}>
                                        User will be created with email/password login via TTAuth
                                    </small>
                                </div>

                                <div className="form-group checkbox-group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="accountEnabled"
                                            checked={newUserData.accountEnabled}
                                            onChange={handleInputChange}
                                        />
                                        Account Enabled
                                    </label>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn-secondary" onClick={handleCloseModal}>
                                    Cancel
                                </button>
                                <button type="submit" className="btn-primary" disabled={loading}>
                                    {loading ? 'Creating...' : 'Create User'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteConfirm && userToDelete && (
                <div className="modal-overlay" onClick={cancelDeleteUser}>
                    <div className="modal-content delete-confirm-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Delete User</h2>
                            <button className="modal-close" onClick={cancelDeleteUser}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="delete-warning">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" style={{marginBottom: '16px'}}>
                                    <circle cx="24" cy="24" r="24" fill="#FEE2E2"/>
                                    <path d="M24 16v12M24 32h.01" stroke="#DC2626" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <p style={{fontSize: '16px', color: '#1C1C1E', marginBottom: '8px', fontWeight: '600'}}>
                                    Are you sure you want to delete this user?
                                </p>
                                <div className="user-info" style={{marginTop: '16px'}}>
                                    <div className="user-avatar">
                                        {userToDelete.displayName?.charAt(0) || 'U'}
                                    </div>
                                    <div className="user-details">
                                        <h3>{userToDelete.displayName}</h3>
                                        <p>{userToDelete.mail || userToDelete.userPrincipalName}</p>
                                    </div>
                                </div>
                                <p style={{fontSize: '14px', color: '#DC2626', marginTop: '16px', padding: '12px', backgroundColor: '#FEE2E2', borderRadius: '6px'}}>
                                    ⚠️ This action cannot be undone. The user will be permanently removed from the system.
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-secondary" onClick={cancelDeleteUser}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-danger"
                                onClick={confirmDeleteUser}
                                disabled={loading}
                            >
                                {loading ? 'Deleting...' : 'Delete User'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Manage Clients Modal - Shows all clients with ability to add new */}
            {showAddClientModal && !showEditClientModal && (
                <div className="modal-overlay" onClick={() => setShowAddClientModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '700px'}}>
                        <div className="modal-header">
                            <h2>Manage Clients</h2>
                            <button className="modal-close" onClick={() => setShowAddClientModal(false)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <div style={{marginBottom: '20px'}}>
                                <button
                                    className="btn-primary"
                                    onClick={() => {
                                        setNewClientData({ name: '', description: '' });
                                        setSelectedClient({ name: '', description: '' });
                                        setShowEditClientModal(true);
                                    }}
                                    style={{width: '100%'}}
                                >
                                    + Add New Client
                                </button>
                            </div>
                            
                            <div className="form-group">
                                <label>Existing Clients ({clients.length})</label>
                                {clients.length === 0 ? (
                                    <div style={{padding: '40px 20px', textAlign: 'center', color: '#8E8E93', border: '2px dashed #E5E5EA', borderRadius: '8px'}}>
                                        <p style={{marginBottom: '8px'}}>No clients yet</p>
                                        <p style={{fontSize: '14px'}}>Click "Add New Client" above to create your first client</p>
                                    </div>
                                ) : (
                                    <div style={{maxHeight: '400px', overflowY: 'auto', border: '1px solid #2A2A2A', borderRadius: '8px'}}>
                                        {clients.map((client) => {
                                            const assignedUsers = Object.entries(userClientsMap)
                                                .filter(([email, clientList]) => clientList.includes(client.name))
                                                .length;
                                            
                                            return (
                                                <div key={client.id} style={{
                                                    padding: '16px',
                                                    borderBottom: '1px solid #2A2A2A',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    transition: 'background-color 0.2s'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#222222'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                                                    <div style={{flex: 1}}>
                                                        <div style={{fontWeight: '600', fontSize: '15px', marginBottom: '6px', color: '#FFFFFF'}}>{client.name}</div>
                                                        <div style={{fontSize: '13px', color: '#999999', marginBottom: '4px'}}>
                                                            {client.description || 'No description'}
                                                        </div>
                                                        <div style={{fontSize: '12px', color: '#3B82F6'}}>
                                                            {assignedUsers} user{assignedUsers !== 1 ? 's' : ''} assigned
                                                        </div>
                                                    </div>
                                                    <div className="action-icons" style={{marginLeft: '16px'}}>
                                                        <button
                                                            className="icon-btn edit-btn"
                                                            onClick={() => handleEditClient(client)}
                                                            title="Edit client"
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M11.333 2A2.827 2.827 0 0 1 14 4.667L12.667 6 10 3.333 11.333 2zM2 14h2.667L12 6.667 9.333 4 2 11.333V14z" fill="currentColor"/>
                                                            </svg>
                                                        </button>
                                                        <button
                                                            className="icon-btn delete-btn"
                                                            onClick={() => handleDeleteClient(client.name)}
                                                            title="Delete client"
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 0 1 1.334-1.334h2.666a1.333 1.333 0 0 1 1.334 1.334V4m2 0v9.333a1.333 1.333 0 0 1-1.334 1.334H4.667a1.333 1.333 0 0 1-1.334-1.334V4h9.334z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-secondary" onClick={() => setShowAddClientModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add/Edit Client Form Modal */}
            {showEditClientModal && (
                <div className="modal-overlay" onClick={() => setShowEditClientModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>{selectedClient?.id ? 'Edit Client' : 'Add New Client'}</h2>
                            <button className="modal-close" onClick={() => setShowEditClientModal(false)}>&times;</button>
                        </div>
                        <form onSubmit={selectedClient?.id ? handleUpdateClient : handleCreateClient}>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Client Name *</label>
                                    <input
                                        type="text"
                                        value={newClientData.name}
                                        onChange={(e) => setNewClientData({...newClientData, name: e.target.value})}
                                        required
                                        placeholder="Enter client name"
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Description</label>
                                    <textarea
                                        value={newClientData.description}
                                        onChange={(e) => setNewClientData({...newClientData, description: e.target.value})}
                                        placeholder="Enter client description (optional)"
                                        rows="3"
                                        style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #E5E5EA'}}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn-secondary" onClick={() => setShowEditClientModal(false)}>
                                    Cancel
                                </button>
                                <button type="submit" className="btn-primary" disabled={loading}>
                                    {loading ? (selectedClient?.id ? 'Updating...' : 'Creating...') : (selectedClient?.id ? 'Update' : 'Create')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Client Assignment Modal */}
            {showClientAssignModal && selectedUserForClient && (
                <div className="modal-overlay" onClick={() => setShowClientAssignModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Manage Client Assignments</h2>
                            <button className="modal-close" onClick={() => setShowClientAssignModal(false)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="user-info">
                                <div className="user-avatar">
                                    {selectedUserForClient.displayName?.charAt(0) || 'U'}
                                </div>
                                <div className="user-details">
                                    <h3>{selectedUserForClient.displayName}</h3>
                                    <p>{selectedUserForClient.mail || selectedUserForClient.userPrincipalName}</p>
                                </div>
                            </div>

                            <div className="form-group" style={{marginTop: '20px'}}>
                                <label>Available Clients</label>
                                {clients.length === 0 ? (
                                    <div style={{padding: '20px', textAlign: 'center', color: '#8E8E93'}}>
                                        <p>No clients available. Add clients first.</p>
                                    </div>
                                ) : (
                                    <div className="features-grid">
                                        {clients.map((client) => {
                                            const email = selectedUserForClient.mail || selectedUserForClient.userPrincipalName;
                                            const isAssigned = (userClientsMap[email] || []).includes(client.name);
                                            
                                            return (
                                                <label
                                                    key={client.id}
                                                    className="feature-checkbox"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={isAssigned}
                                                        onChange={() => handleClientAssignment(client.name, isAssigned ? 'remove' : 'add')}
                                                    />
                                                    <span>{client.name}</span>
                                                </label>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-secondary" onClick={() => setShowClientAssignModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit/Add Role Modal */}
            {showRoleModal && (
                <div className="modal-overlay" onClick={handleCloseRoleModal}>
                    <div className="modal-content role-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>{selectedClient ? 'Manage Client Features' : (editingRole ? 'Edit Role' : 'Add Role')}</h2>
                            <button className="modal-close" onClick={handleCloseRoleModal}>&times;</button>
                        </div>
                        <div className="modal-body">
                            {selectedClient ? (
                                <div className="form-group">
                                    <label>Client Name</label>
                                    <input
                                        type="text"
                                        value={roleFormData.name}
                                        disabled
                                        className="role-name-input"
                                        style={{backgroundColor: '#F9F9F9', color: '#1C1C1E'}}
                                    />
                                    {selectedClient.description && (
                                        <small style={{color: '#8E8E93', fontSize: '12px', marginTop: '4px', display: 'block'}}>
                                            {selectedClient.description}
                                        </small>
                                    )}
                                </div>
                            ) : (
                                <div className="form-group">
                                    <label>Select User</label>
                                    {editingRole ? (
                                        <input
                                            type="text"
                                            value={roleFormData.name}
                                            disabled
                                            className="role-name-input"
                                        />
                                    ) : (
                                        <select
                                            value={roleFormData.name}
                                            onChange={(e) => handleUserSelection(e.target.value)}
                                            className="role-name-input"
                                        >
                                            <option value="">Select a user</option>
                                            {users.map(user => (
                                                <option key={user.id} value={user.mail || user.userPrincipalName}>
                                                    {user.displayName} ({user.mail || user.userPrincipalName})
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                </div>
                            )}

                            <div className="form-group">
                                {(() => {
                                    // Get all unique SPNs from client assignments if allSpns is empty
                                    const availableSpns = allSpns.length > 0 ? allSpns :
                                        [...new Set(Object.values(clientSpnsMap).flat())];
                                    
                                    return (
                                        <>
                                            <label>Features ({availableSpns.length} available)</label>
                                            {spnLoading ? (
                                                <div style={{padding: '20px', textAlign: 'center', color: '#8E8E93'}}>
                                                    <p>Loading features...</p>
                                                </div>
                                            ) : availableSpns.length === 0 ? (
                                                <div style={{padding: '20px', textAlign: 'center', color: '#8E8E93'}}>
                                                    <p>No features available. Click "Sync from Databricks" to load SPNs.</p>
                                                </div>
                                            ) : (
                                                <div className="features-grid">
                                                    {availableSpns.map((spn) => {
                                                        // For clients, no concept of "existing" features - all are editable
                                                        const existingSpns = (!editingRole && !selectedClient) ? getExistingSpnsForUser(roleFormData.name) : [];
                                                        const isExisting = existingSpns.includes(spn);
                                                        const isChecked = roleFormData.features.includes(spn);
                                                        
                                                        return (
                                                            <label
                                                                key={spn}
                                                                className={`feature-checkbox ${isExisting ? 'existing-feature' : ''}`}
                                                                title={isExisting ? 'Already assigned (cannot be removed)' : ''}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isChecked}
                                                                    onChange={() => handleFeatureToggle(spn, isExisting)}
                                                                    disabled={isExisting}
                                                                />
                                                                <span>{spn.replace(/^spn_/i, '')}</span>
                                                            </label>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </>
                                    );
                                })()}
                            </div>

                            {/* Dashboards Section - Only for clients */}
                            {selectedClient && (
                                <div className="form-group" style={{marginTop: '24px', paddingTop: '24px', borderTop: '2px solid #E5E5EA'}}>
                                    <label>Power BI Dashboards ({availableDashboards.length} available)</label>
                                    <p style={{fontSize: '13px', color: '#8E8E93', marginBottom: '12px'}}>
                                        Grant access to specific Power BI dashboards
                                    </p>
                                    {availableDashboards.length === 0 ? (
                                        <div style={{padding: '20px', textAlign: 'center', color: '#8E8E93', border: '1px solid #E5E5EA', borderRadius: '8px'}}>
                                            <p>No Power BI dashboards configured. Check PowerBI.json configuration.</p>
                                        </div>
                                    ) : (
                                        <div className="features-grid">
                                           {availableDashboards.map((dashboard) => {
                                               const isChecked = roleFormData.features.includes(dashboard.id);
                                               
                                               return (
                                                   <div key={dashboard.id} style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                                       <label
                                                           className="feature-checkbox powerbi-feature"
                                                           style={{
                                                               backgroundColor: '#F0F7FF',
                                                               borderColor: '#007AFF',
                                                               padding: '12px 16px',
                                                               flex: 1
                                                           }}
                                                       >
                                                           <input
                                                               type="checkbox"
                                                               checked={isChecked}
                                                               onChange={() => handleFeatureToggle(dashboard.id, false)}
                                                           />
                                                           <span style={{fontWeight: '600', color: '#007AFF', fontSize: '14px'}}>
                                                               📊 {dashboard.name}
                                                           </span>
                                                       </label>
                                                       {/* Preview button — only meaningful when editing a specific client */}
                                                       {selectedClient && (
                                                           <button
                                                               type="button"
                                                               onClick={() => handlePreviewClientDashboard(selectedClient, dashboard.id, dashboard.name)}
                                                               style={{
                                                                   padding: '5px 12px',
                                                                   borderRadius: '6px',
                                                                   border: '1px solid #007AFF',
                                                                   backgroundColor: '#fff',
                                                                   color: '#007AFF',
                                                                   fontSize: '12px',
                                                                   fontWeight: '600',
                                                                   cursor: 'pointer',
                                                                   whiteSpace: 'nowrap',
                                                                   flexShrink: 0
                                                               }}
                                                               title={`Preview "${dashboard.name}" scoped to client "${selectedClient.name}"`}
                                                           >
                                                               👁 Preview
                                                           </button>
                                                       )}
                                                   </div>
                                               );
                                           })}
                                       </div>
                                    )}
                                </div>
                            )}

                            {/* Databricks AI/BI Dashboards Section - Only for clients */}
                            {selectedClient && (
                                <div className="form-group" style={{marginTop: '24px', paddingTop: '24px', borderTop: '2px solid #E5E5EA'}}>
                                    <label style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                        <span style={{
                                            display: 'inline-block',
                                            background: 'linear-gradient(135deg, #ff3621 0%, #ff6944 100%)',
                                            color: '#fff',
                                            fontSize: '10px',
                                            fontWeight: '700',
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            letterSpacing: '0.4px',
                                            textTransform: 'uppercase'
                                        }}>Databricks</span>
                                        AI/BI Dashboards ({availableDatabricksDashboards.length} available)
                                    </label>
                                    <p style={{fontSize: '13px', color: '#8E8E93', marginBottom: '12px'}}>
                                        Grant access to specific Databricks AI/BI dashboards
                                    </p>
                                    {availableDatabricksDashboards.length === 0 ? (
                                        <div style={{padding: '20px', textAlign: 'center', color: '#8E8E93', border: '1px solid #E5E5EA', borderRadius: '8px'}}>
                                            <p>No Databricks AI/BI dashboards configured. Check PowerBI.json configuration.</p>
                                        </div>
                                    ) : (
                                        <div className="features-grid">
                                            {availableDatabricksDashboards.map((dashboard) => {
                                                const isChecked = roleFormData.features.includes(dashboard.id);
                                                return (
                                                    <label
                                                        key={dashboard.id}
                                                        className="feature-checkbox powerbi-feature"
                                                        style={{
                                                            backgroundColor: '#FFF4F2',
                                                            borderColor: '#ff3621',
                                                            padding: '12px 16px'
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={isChecked}
                                                            onChange={() => handleFeatureToggle(dashboard.id, false)}
                                                        />
                                                        <span style={{fontWeight: '600', color: '#ff3621', fontSize: '14px'}}>
                                                            🧱 {dashboard.name}
                                                        </span>
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-secondary" onClick={handleCloseRoleModal}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-primary"
                                onClick={handleSaveRole}
                                disabled={spnLoading}
                            >
                                {spnLoading ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

{/* Bulk Import Modal */}
            {showBulkImportModal && (
                <div className="modal-overlay" onClick={closeBulkImportModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '900px', maxHeight: '90vh', overflowY: 'auto'}}>
                        <div className="modal-header">
                            <h2>Bulk Import Users</h2>
                            <button className="modal-close" onClick={closeBulkImportModal}>&times;</button>
                        </div>
                        <div className="modal-body">
                            {/* Instructions */}
                            <div style={{
                                padding: '16px',
                                backgroundColor: '#F0F7FF',
                                border: '1px solid #007AFF',
                                borderRadius: '8px',
                                marginBottom: '20px'
                            }}>
                                <h3 style={{fontSize: '15px', fontWeight: '600', marginBottom: '8px', color: '#007AFF'}}>
                                    📋 How to use Bulk Import
                                </h3>
                                <ol style={{fontSize: '13px', color: '#1C1C1E', paddingLeft: '20px', margin: 0}}>
                                    <li>Download the CSV template</li>
                                    <li>Fill in user details (Display Name and Email are required)</li>
                                    <li>Upload the completed file</li>
                                    <li>Review the preview and fix any errors</li>
                                    <li>Click "Create Users" to import all users</li>
                                </ol>
                            </div>

                            {/* Download Template */}
                            <div className="form-group">
                                <label>Step 1: Download Template</label>
                                <button
                                    type="button"
                                    className="btn-primary"
                                    onClick={handleDownloadTemplate}
                                    style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'}}
                                >
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M10 2v10m0 0l3-3m-3 3L7 9m9 5v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Download CSV Template
                                </button>
                            </div>

                            {/* Upload File */}
                            <div className="form-group">
                                <label>Step 2: Upload Completed File</label>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={handleFileUpload}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '2px dashed #E5E5EA',
                                        borderRadius: '8px',
                                        cursor: 'pointer'
                                    }}
                                />
                                {bulkImportFile && (
                                    <small style={{color: '#007AFF', fontSize: '12px', marginTop: '4px', display: 'block'}}>
                                        ✓ File uploaded: {bulkImportFile.name}
                                    </small>
                                )}
                            </div>

                            {/* Errors */}
                            {bulkImportErrors.length > 0 && (
                                <div style={{
                                    padding: '12px',
                                    backgroundColor: '#FEE2E2',
                                    border: '1px solid #DC2626',
                                    borderRadius: '8px',
                                    marginBottom: '20px'
                                }}>
                                    <h4 style={{fontSize: '14px', fontWeight: '600', color: '#DC2626', marginBottom: '8px'}}>
                                        ⚠️ Errors Found ({bulkImportErrors.length})
                                    </h4>
                                    <ul style={{fontSize: '13px', color: '#DC2626', paddingLeft: '20px', margin: 0}}>
                                        {bulkImportErrors.map((error, idx) => (
                                            <li key={idx}>{error}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {/* Success Message */}
                            {bulkImportSuccess && (
                                <div style={{
                                    padding: '12px',
                                    backgroundColor: '#D1FAE5',
                                    border: '1px solid #10B981',
                                    borderRadius: '8px',
                                    marginBottom: '20px'
                                }}>
                                    <h4 style={{fontSize: '14px', fontWeight: '600', color: '#10B981', marginBottom: '8px'}}>
                                        ✓ Success
                                    </h4>
                                    <pre style={{fontSize: '12px', color: '#10B981', margin: 0, whiteSpace: 'pre-wrap'}}>
                                        {bulkImportSuccess}
                                    </pre>
                                </div>
                            )}

                            {/* Preview */}
                            {bulkImportData.length > 0 && (
                                <div className="form-group">
                                    <label>Step 3: Preview ({bulkImportData.length} user{bulkImportData.length !== 1 ? 's' : ''})</label>
                                    <div style={{
                                        border: '1px solid #E5E5EA',
                                        borderRadius: '8px',
                                        maxHeight: '300px',
                                        overflowY: 'auto'
                                    }}>
                                        <table style={{width: '100%', fontSize: '13px'}}>
                                            <thead style={{backgroundColor: '#F9F9F9', position: 'sticky', top: 0}}>
                                                <tr>
                                                    <th style={{padding: '12px', textAlign: 'left', borderBottom: '1px solid #E5E5EA'}}>#</th>
                                                    <th style={{padding: '12px', textAlign: 'left', borderBottom: '1px solid #E5E5EA'}}>Display Name</th>
                                                    <th style={{padding: '12px', textAlign: 'left', borderBottom: '1px solid #E5E5EA'}}>Email</th>
                                                    <th style={{padding: '12px', textAlign: 'left', borderBottom: '1px solid #E5E5EA'}}>Enabled</th>
                                                    <th style={{padding: '12px', textAlign: 'left', borderBottom: '1px solid #E5E5EA'}}>Send Invite</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bulkImportData.map((user, idx) => (
                                                    <tr key={idx} style={{borderBottom: '1px solid #E5E5EA'}}>
                                                        <td style={{padding: '12px'}}>{idx + 1}</td>
                                                        <td style={{padding: '12px', fontWeight: '500'}}>{user.displayName}</td>
                                                        <td style={{padding: '12px', color: '#007AFF'}}>{user.userPrincipalName}</td>
                                                        <td style={{padding: '12px'}}>
                                                            <span style={{
                                                                padding: '2px 8px',
                                                                borderRadius: '4px',
                                                                fontSize: '11px',
                                                                backgroundColor: user.accountEnabled ? '#D1FAE5' : '#FEE2E2',
                                                                color: user.accountEnabled ? '#10B981' : '#DC2626'
                                                            }}>
                                                                {user.accountEnabled ? 'Yes' : 'No'}
                                                            </span>
                                                        </td>
                                                        <td style={{padding: '12px'}}>
                                                            <span style={{
                                                                padding: '2px 8px',
                                                                borderRadius: '4px',
                                                                fontSize: '11px',
                                                                backgroundColor: user.sendInvitationMessage ? '#D1FAE5' : '#FEE2E2',
                                                                color: user.sendInvitationMessage ? '#10B981' : '#DC2626'
                                                            }}>
                                                                {user.sendInvitationMessage ? 'Yes' : 'No'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-secondary" onClick={closeBulkImportModal}>
                                Cancel
                            </button>
                            {bulkImportData.length > 0 && (
                                <button
                                    type="button"
                                    className="btn-primary"
                                    onClick={handleBulkCreateUsers}
                                    disabled={bulkImportLoading || bulkImportErrors.length > 0}
                                >
                                    {bulkImportLoading ? 'Creating Users...' : `Create ${bulkImportData.length} User${bulkImportData.length !== 1 ? 's' : ''}`}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {/* Edit User Modal */}
            {showEditUserModal && selectedUser && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '600px'}}>
                        <div className="modal-header">
                            <h2>Edit User</h2>
                            <button className="modal-close" onClick={handleCloseModal}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="user-info">
                                <div className="user-avatar">
                                    {selectedUser.displayName?.charAt(0) || 'U'}
                                </div>
                                <div className="user-details">
                                    <h3>{selectedUser.displayName}</h3>
                                    <p>{selectedUser.mail || selectedUser.userPrincipalName}</p>
                                </div>
                            </div>

                            <div className="form-group" style={{marginTop: '24px'}}>
                                <label>User Role</label>
                                <div className="role-options">
                                    {/* Super Admin option — only visible to Super Admins */}
                                    {currentUser?.role === 'super_admin' && (
                                        <button
                                            type="button"
                                            className={`role-option ${selectedUser.role === 'super_admin' ? 'active super_admin' : ''}`}
                                            onClick={() => handleUpdateUserRole(selectedUser, 'super_admin')}
                                            disabled={loading}
                                        >
                                            <span className="role-badge super_admin">Super Admin</span>
                                            <p>Full control including user role promotion</p>
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className={`role-option ${selectedUser.role === 'admin' ? 'active admin' : ''}`}
                                        onClick={() => handleUpdateUserRole(selectedUser, 'admin')}
                                        disabled={loading}
                                    >
                                        <span className="role-badge admin">Admin</span>
                                        <p>Full access to all features</p>
                                    </button>
                                    <button
                                        type="button"
                                        className={`role-option ${selectedUser.role === 'viewer' ? 'active viewer' : ''}`}
                                        onClick={() => handleUpdateUserRole(selectedUser, 'viewer')}
                                        disabled={loading}
                                    >
                                        <span className="role-badge viewer">Viewer</span>
                                        <p>Read-only access</p>
                                    </button>
                                </div>
                            </div>

                            <div className="form-group" style={{marginTop: '24px'}}>
                                <label>Assigned Clients</label>
                                {clients.length === 0 ? (
                                    <div style={{padding: '20px', textAlign: 'center', color: '#8E8E93', border: '1px solid #E5E5EA', borderRadius: '8px'}}>
                                        <p>No clients available. Create clients first.</p>
                                    </div>
                                ) : (
                                    <div className="features-grid">
                                        {clients.map((client) => {
                                            const email = selectedUser.mail || selectedUser.userPrincipalName;
                                            const isAssigned = (userClientsMap[email] || []).includes(client.name);
                                            
                                            return (
                                                <label
                                                    key={client.id}
                                                    className="feature-checkbox"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={isAssigned}
                                                        onChange={() => handleClientAssignment(client.name, isAssigned ? 'remove' : 'add')}
                                                        disabled={loading}
                                                    />
                                                    <span>{client.name}</span>
                                                </label>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-secondary" onClick={handleCloseModal}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminDashboard;
